function prepareSharedDrawerForCart(options) {
  var drawer = document.querySelector("[data-side-drawer]");
  if (!drawer) return null;
  if (typeof cancelQuickViewRequest === "function") {
    cancelQuickViewRequest(drawer);
  }
  if (typeof hideQuickViewLoader === "function") hideQuickViewLoader();
  var drawerBody = drawer.querySelector("[data-drawer-body]");
  if (
    drawerBody &&
    (!options || options.disposeProductLifecycle !== false) &&
    typeof disposeProductVariantLifecycle === "function"
  ) {
    disposeProductVariantLifecycle(drawerBody);
  }
  if (typeof claimSharedDrawerOwnership === "function") {
    var sharedOwnership = claimSharedDrawerOwnership(drawer, "cart");
    drawer.upvCartDrawerOwnership = sharedOwnership;
    return sharedOwnership;
  }
  var fallbackOwnership = {
    cancelled: false,
    drawer: drawer,
    generation: 0,
    owner: "cart",
    requests: []
  };
  drawer.upvCartDrawerOwnership = fallbackOwnership;
  return fallbackOwnership;
}

function isCartDrawerOwnershipCurrent(ownership) {
  if (!ownership || !ownership.drawer) return false;
  if (typeof isSharedDrawerOwnershipCurrent === "function") {
    return isSharedDrawerOwnershipCurrent(ownership);
  }
  return !ownership.cancelled && ownership.drawer.isConnected !== false;
}

function trackCartDrawerRequest(ownership, request) {
  if (typeof trackSharedDrawerRequest === "function") {
    return trackSharedDrawerRequest(ownership, request);
  }
  return request;
}

function setCartDrawerState(ownership, showLoader) {
  if (!isCartDrawerOwnershipCurrent(ownership)) return false;
  var drawer = ownership.drawer;
  var drawerBody = drawer.querySelector("[data-drawer-body]");
  var drawerTitle = drawer.querySelector("[data-drawer-title]");
  if (!drawerBody || !drawerTitle) return false;
  if (showLoader) {
    var noteRenderState =
      typeof captureCartNoteRenderState === "function"
        ? captureCartNoteRenderState(drawerBody)
        : null;
    if (
      noteRenderState &&
      noteRenderState.compositionInterrupted &&
      typeof scheduleCartNoteSave === "function"
    ) {
      scheduleCartNoteSave(750);
    }
    if (typeof disposeProductVariantLifecycle === "function") {
      disposeProductVariantLifecycle(drawerBody);
    }
    drawerBody.innerHTML = preLoadLoadGif;
  }
  drawerBody.classList.remove("searching");
  drawer.setAttribute("class", "yv_side_drawer_wrapper");
  drawer.setAttribute("id", "mini__cart");
  drawer.classList.add("mini_cart");
  drawer.upvQuickViewTrigger = null;
  drawerTitle.innerHTML = cartTitleLabel;
  return true;
}

function cartAddNodeWillBeRemoved(node, ownership, removalRoot) {
  if (!node) return false;
  if (node.isConnected === false) return true;
  if (
    removalRoot &&
    typeof removalRoot.contains === "function" &&
    removalRoot.contains(node)
  ) return true;
  if (!isCartDrawerOwnershipCurrent(ownership)) return false;
  var drawerBody = ownership.drawer.querySelector("[data-drawer-body]");
  return !!(
    drawerBody &&
    typeof drawerBody.contains === "function" &&
    drawerBody.contains(node)
  );
}

function cartAddActiveElementWillBeRemoved(ownership, removalRoot) {
  return cartAddNodeWillBeRemoved(
    document.activeElement,
    ownership,
    removalRoot
  );
}

function focusCartDrawerRoot(ownership) {
  if (!isCartDrawerOwnershipCurrent(ownership)) return false;
  var drawer = ownership.drawer;
  if (!drawer || typeof drawer.focus !== "function") return false;
  try {
    drawer.focus({ preventScroll: true });
  } catch (error) {
    try {
      drawer.focus();
    } catch (focusError) {
      return false;
    }
  }
  return document.activeElement === drawer;
}

function showCartDrawerFallback(ownership, focusFallback) {
  if (!isCartDrawerOwnershipCurrent(ownership)) return false;
  var drawerBody = ownership.drawer.querySelector("[data-drawer-body]");
  if (!drawerBody) return false;
  var noteRenderState =
    typeof captureCartNoteRenderState === "function"
      ? captureCartNoteRenderState(drawerBody)
      : null;
  if (
    noteRenderState &&
    noteRenderState.compositionInterrupted &&
    typeof scheduleCartNoteSave === "function"
  ) {
    scheduleCartNoteSave(750);
  }
  drawerBody.innerHTML = "";
  var fallbackLink = document.createElement("a");
  fallbackLink.href = mainCartUrl;
  fallbackLink.className = "button";
  fallbackLink.textContent = cartTitleLabel;
  drawerBody.appendChild(fallbackLink);
  if (typeof refreshCartDrawerFocusRotation === "function") {
    refreshCartDrawerFocusRotation(ownership.drawer);
  }
  if (focusFallback && typeof fallbackLink.focus === "function") {
    try {
      fallbackLink.focus({ preventScroll: true });
    } catch (error) {
      fallbackLink.focus();
    }
  }
  restoreCartInteractionState();
  return true;
}

function updateCartIndicators(cart) {
  if (!cart || typeof cart.item_count === "undefined") return;
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if (cartItemsCount > 0 && cartItemsCount < 100) {
    $("[data-cart-count]").text(cart.item_count);
  } else {
    $("[data-cart-count]").text("");
  }
  if (favicon && typeof favicon.badge === "function") {
    try {
      favicon.badge(cartItemsCount);
    } catch (error) {}
  }
}

var cartQuantityMutationStates =
  window.UpvanityCartQuantityMutations &&
  typeof window.UpvanityCartQuantityMutations.get === "function" &&
  typeof window.UpvanityCartQuantityMutations.set === "function" &&
  typeof window.UpvanityCartQuantityMutations.delete === "function"
    ? window.UpvanityCartQuantityMutations
    : new Map();
window.UpvanityCartQuantityMutations = cartQuantityMutationStates;

var cartQuantityMutationCoordinator =
  window.UpvanityCartQuantityMutationCoordinator &&
  typeof window.UpvanityCartQuantityMutationCoordinator === "object" &&
  window.UpvanityCartQuantityMutationCoordinator.states ===
    cartQuantityMutationStates
    ? window.UpvanityCartQuantityMutationCoordinator
    : {
        active: false,
        activeState: null,
        allSucceeded: true,
        lastCart: null,
        latestCallback: null,
        sequence: 0,
        states: cartQuantityMutationStates
      };
window.UpvanityCartQuantityMutationCoordinator =
  cartQuantityMutationCoordinator;
if (!Array.isArray(cartQuantityMutationCoordinator.externalQueue)) {
  cartQuantityMutationCoordinator.externalQueue = [];
}
if (!Array.isArray(cartQuantityMutationCoordinator.finalizers)) {
  cartQuantityMutationCoordinator.finalizers = [];
}
if (!Array.isArray(cartQuantityMutationCoordinator.failures)) {
  cartQuantityMutationCoordinator.failures = [];
}
if (typeof cartQuantityMutationCoordinator.latestResultSequence !== "number") {
  cartQuantityMutationCoordinator.latestResultSequence = 0;
}
if (typeof cartQuantityMutationCoordinator.latestSucceeded !== "boolean") {
  cartQuantityMutationCoordinator.latestSucceeded = true;
}

var cartAddLifecycle =
  window.UpvanityCartAddLifecycle &&
  typeof window.UpvanityCartAddLifecycle === "object"
    ? window.UpvanityCartAddLifecycle
    : {};
if (
  !cartAddLifecycle.states ||
  typeof cartAddLifecycle.states.get !== "function" ||
  typeof cartAddLifecycle.states.set !== "function" ||
  typeof cartAddLifecycle.states.delete !== "function"
) {
  cartAddLifecycle.states = new WeakMap();
}
if (
  !cartAddLifecycle.ids ||
  typeof cartAddLifecycle.ids.get !== "function" ||
  typeof cartAddLifecycle.ids.set !== "function" ||
  typeof cartAddLifecycle.ids.delete !== "function"
) {
  cartAddLifecycle.ids = new Map();
}
if (typeof cartAddLifecycle.token !== "number") {
  cartAddLifecycle.token = 0;
}
cartAddLifecycle.version = 3;
window.UpvanityCartAddLifecycle = cartAddLifecycle;

var quickAddPopupLifecycle =
  window.UpvanityQuickAddPopupLifecycle &&
  typeof window.UpvanityQuickAddPopupLifecycle === "object"
    ? window.UpvanityQuickAddPopupLifecycle
    : {};
if (typeof quickAddPopupLifecycle.token !== "number") {
  quickAddPopupLifecycle.token = 0;
}
quickAddPopupLifecycle.version = 1;
window.UpvanityQuickAddPopupLifecycle = quickAddPopupLifecycle;

function getQuickAddPopupBody(popup, fallbackBody) {
  if (!popup) return null;
  var currentBody =
    typeof popup.querySelector === "function"
      ? popup.querySelector("[quick-add-body]")
      : null;
  return currentBody || fallbackBody || null;
}

function claimQuickAddPopupGeneration(popup, body, trigger) {
  if (!popup || !body || !trigger) return null;
  if (
    popup.upvQuickAddTrigger !== trigger ||
    getQuickAddPopupBody(popup, body) !== body
  ) return null;
  quickAddPopupLifecycle.token += 1;
  popup.upvQuickAddGeneration = quickAddPopupLifecycle.token;
  popup.upvQuickAddTriggerGeneration = quickAddPopupLifecycle.token;
  return quickAddPopupLifecycle.token;
}

function captureQuickAddPopupGeneration(
  popup,
  body,
  trigger,
  formElement
) {
  if (!popup || !body || !trigger) return null;
  var generation = popup.upvQuickAddGeneration;
  if (
    typeof generation !== "number" ||
    popup.upvQuickAddTriggerGeneration !== generation
  ) {
    generation = claimQuickAddPopupGeneration(popup, body, trigger);
  }
  if (
    typeof generation !== "number" ||
    popup.upvQuickAddTrigger !== trigger ||
    popup.upvQuickAddTriggerGeneration !== generation ||
    getQuickAddPopupBody(popup, body) !== body
  ) return null;
  return {
    body: body,
    form: formElement || null,
    generation: generation,
    popup: popup,
    trigger: trigger
  };
}

function quickAddPopupSnapshotOwnsTrigger(snapshot) {
  return Boolean(
    snapshot &&
    snapshot.popup &&
    snapshot.popup.upvQuickAddGeneration === snapshot.generation &&
    snapshot.popup.upvQuickAddTriggerGeneration === snapshot.generation &&
    snapshot.popup.upvQuickAddTrigger === snapshot.trigger
  );
}

function isQuickAddPopupSnapshotCurrent(snapshot) {
  if (!quickAddPopupSnapshotOwnsTrigger(snapshot)) return false;
  if (
    snapshot.popup.isConnected === false ||
    snapshot.body.isConnected === false ||
    getQuickAddPopupBody(snapshot.popup, snapshot.body) !== snapshot.body ||
    (
      snapshot.popup.classList &&
      typeof snapshot.popup.classList.contains === "function" &&
      !snapshot.popup.classList.contains("show")
    )
  ) return false;
  if (
    snapshot.form &&
    typeof snapshot.body.contains === "function" &&
    !snapshot.body.contains(snapshot.form)
  ) return false;
  return true;
}

function retireQuickAddPopupGeneration(snapshot) {
  if (!quickAddPopupSnapshotOwnsTrigger(snapshot)) return false;
  snapshot.popup.upvQuickAddTrigger = null;
  snapshot.popup.upvQuickAddTriggerGeneration = null;
  quickAddPopupLifecycle.token += 1;
  snapshot.popup.upvQuickAddGeneration = quickAddPopupLifecycle.token;
  return true;
}

function findCartQuickAddEventTarget(eventTarget, selector) {
  return eventTarget && typeof eventTarget.closest === "function"
    ? eventTarget.closest(selector)
    : null;
}

function installQuickAddPopupGenerationGuard() {
  if (
    typeof document === "undefined" ||
    !document.addEventListener
  ) return;
  if (
    quickAddPopupLifecycle.clickHandler &&
    document.removeEventListener
  ) {
    document.removeEventListener(
      "click",
      quickAddPopupLifecycle.clickHandler,
      false
    );
  }
  quickAddPopupLifecycle.clickHandler = function (event) {
    var eventTarget = event && event.target;
    var toggle = findCartQuickAddEventTarget(
      eventTarget,
      "quick-add-toggle"
    );
    if (toggle) {
      var togglePopup = toggle.popup ||
        (typeof document.querySelector === "function"
          ? document.querySelector(".quick-add-popup")
          : null);
      var toggleBody = toggle.popBody ||
        getQuickAddPopupBody(togglePopup, null);
      if (
        togglePopup &&
        toggleBody &&
        togglePopup.upvQuickAddTrigger === toggle
      ) {
        claimQuickAddPopupGeneration(togglePopup, toggleBody, toggle);
        rememberCartAddTermsRequirementInScope(toggleBody);
      }
      return;
    }
    var close = findCartQuickAddEventTarget(
      eventTarget,
      "quick-add-close"
    );
    if (!close) return;
    var closePopup = close.parent ||
      (typeof close.closest === "function"
        ? close.closest(".quick-add-popup")
        : null);
    if (!closePopup) return;
    retireQuickAddPopupGeneration({
      generation: closePopup.upvQuickAddGeneration,
      popup: closePopup,
      trigger: closePopup.upvQuickAddTrigger
    });
  };
  document.addEventListener(
    "click",
    quickAddPopupLifecycle.clickHandler,
    false
  );
}

function markCartAddTermsRequirement(root) {
  if (!root || typeof root.querySelector !== "function") return null;
  var termsWrapper = root.querySelector(
    "[data-terms-conditions-wrapper]"
  );
  var initialTermsLock = root.querySelector(
    '[data-upv-initial-theme-lock="terms"]'
  );
  if (termsWrapper || initialTermsLock) {
    root.upvCartAddTermsRequired = true;
  }
  return termsWrapper;
}

function rememberCartAddTermsRequirementInScope(scope) {
  if (!scope) return;
  var roots = [];
  if (
    scope.classList &&
    typeof scope.classList.contains === "function" &&
    scope.classList.contains("yv_product_content_section")
  ) {
    roots.push(scope);
  }
  if (typeof scope.querySelectorAll === "function") {
    roots = roots.concat(
      Array.from(scope.querySelectorAll(".yv_product_content_section"))
    );
  }
  roots.forEach(markCartAddTermsRequirement);
}

function isCartAddVariantBoundaryBlocked(variantRoot) {
  if (!variantRoot || typeof variantRoot.querySelector !== "function") {
    return false;
  }
  var activeGuard = variantRoot.upvVariantPurchaseGuard;
  if (activeGuard && activeGuard.active === true) return true;
  var termsWrapper = markCartAddTermsRequirement(variantRoot);
  if (!termsWrapper) {
    return variantRoot.upvCartAddTermsRequired === true;
  }
  var termsInput =
    typeof termsWrapper.querySelector === "function"
      ? termsWrapper.querySelector('[name="terms_conditions"]')
      : null;
  return !termsInput || termsInput.checked !== true;
}

function getCartAddVariantRoot(formElement) {
  if (!formElement) return null;
  if (typeof getProductVariantRoot === "function") {
    try {
      var stableRoot = getProductVariantRoot(formElement);
      if (stableRoot) return stableRoot;
    } catch (error) {}
  }
  if (typeof formElement.closest !== "function") return null;
  try {
    return formElement.closest(".yv_product_content_section");
  } catch (error) {
    return null;
  }
}

if (typeof document !== "undefined") {
  rememberCartAddTermsRequirementInScope(document);
}
installQuickAddPopupGenerationGuard();

function captureAccessibleCartReturnFocus(target) {
  var focusOwner = window.UpvanityCartFocusOwner;
  if (
    !target ||
    !focusOwner ||
    typeof focusOwner.capture !== "function"
  ) return null;
  try {
    return focusOwner.capture(target);
  } catch (error) {
    return null;
  }
}

function releaseAccessibleCartReturnFocus(ownership) {
  var focusOwner = window.UpvanityCartFocusOwner;
  if (
    !ownership ||
    !focusOwner ||
    typeof focusOwner.release !== "function"
  ) return false;
  try {
    return focusOwner.release(ownership);
  } catch (error) {
    return false;
  }
}

function getCartAddFormElement(button) {
  if (!button) return null;
  if (button.form && button.form.nodeName === "FORM") return button.form;
  var formId =
    typeof button.getAttribute === "function"
      ? button.getAttribute("form")
      : null;
  if (formId && document.getElementById) {
    var associatedForm = document.getElementById(formId);
    if (associatedForm && associatedForm.nodeName === "FORM") {
      return associatedForm;
    }
  }
  if (typeof button.closest === "function") {
    return button.closest("form");
  }
  return null;
}

function getCartAddFormId(form) {
  if (!form || typeof form.getAttribute !== "function") return "";
  var formId = form.getAttribute("id");
  return typeof formId === "string" ? formId.trim() : "";
}

function getActiveCartAddState(form) {
  if (!form) return null;
  var formState = cartAddLifecycle.states.get(form);
  if (formState) return formState;
  var formId = getCartAddFormId(form);
  return formId ? cartAddLifecycle.ids.get(formId) || null : null;
}

function getCartAddButtonsForForm(form, sourceButton, formId) {
  var buttons = [];
  var addButton = function (button) {
    if (!button || buttons.indexOf(button) > -1) return;
    var buttonForm = getCartAddFormElement(button);
    if (
      button !== sourceButton &&
      buttonForm !== form &&
      !(
        formId &&
        buttonForm &&
        getCartAddFormId(buttonForm) === formId
      )
    ) return;
    buttons.push(button);
  };
  if (document.querySelectorAll) {
    Array.prototype.forEach.call(
      document.querySelectorAll(".Sd_addProduct"),
      addButton
    );
  }
  addButton(sourceButton);
  return buttons;
}

function applyCartAddPendingState(state) {
  if (
    !state ||
    state.released ||
    cartAddLifecycle.states.get(state.form) !== state
  ) return;
  if (state.timer) clearTimeout(state.timer);
  state.timer = null;
  getCartAddButtonsForForm(
    state.form,
    state.sourceButton,
    state.formId
  ).forEach(function (button) {
    var alreadyTracked = state.buttonStates.some(function (buttonState) {
      return buttonState.button === button;
    });
    if (alreadyTracked) return;
    var buttonState = {
      ariaBusy: button.getAttribute("aria-busy"),
      ariaDisabled: button.getAttribute("aria-disabled"),
      button: button,
      marker: button.getAttribute("data-upv-cart-add-pending")
    };
    button.setAttribute("data-upv-cart-add-pending", String(state.token));
    button.setAttribute("aria-busy", "true");
    button.setAttribute("aria-disabled", "true");
    state.buttonStates.push(buttonState);
  });
}

function acquireCartAddMutation(form, sourceButton) {
  if (!form || getActiveCartAddState(form)) return null;
  cartAddLifecycle.token += 1;
  var formId = getCartAddFormId(form);
  var state = {
    buttonStates: [],
    form: form,
    formId: formId,
    released: false,
    sourceButton: sourceButton,
    sourceHadLoading:
      !!sourceButton && sourceButton.classList.contains("is-loading"),
    sourceLoadingMarker:
      sourceButton && typeof sourceButton.getAttribute === "function"
        ? sourceButton.getAttribute("data-upv-cart-add-loading")
        : null,
    timer: null,
    token: cartAddLifecycle.token
  };
  cartAddLifecycle.states.set(form, state);
  if (formId) cartAddLifecycle.ids.set(formId, state);
  if (sourceButton) {
    sourceButton.setAttribute(
      "data-upv-cart-add-loading",
      String(state.token)
    );
    sourceButton.classList.add("is-loading");
  }
  state.timer = setTimeout(function () {
    applyCartAddPendingState(state);
  }, 0);
  return state;
}

function restoreOwnedCartAddAttribute(button, name, previousValue, ownedValue) {
  if (!button || button.getAttribute(name) !== ownedValue) return;
  if (previousValue === null) button.removeAttribute(name);
  else button.setAttribute(name, previousValue);
}

function releaseCartAddMutation(state) {
  if (!state || state.released) return false;
  state.released = true;
  if (state.timer) clearTimeout(state.timer);
  state.timer = null;
  if (cartAddLifecycle.states.get(state.form) === state) {
    cartAddLifecycle.states.delete(state.form);
  }
  if (
    state.formId &&
    cartAddLifecycle.ids.get(state.formId) === state
  ) {
    cartAddLifecycle.ids.delete(state.formId);
  }
  state.buttonStates.forEach(function (buttonState) {
    var button = buttonState.button;
    var token = String(state.token);
    if (!button || button.getAttribute("data-upv-cart-add-pending") !== token) {
      return;
    }
    restoreOwnedCartAddAttribute(
      button,
      "aria-busy",
      buttonState.ariaBusy,
      "true"
    );
    restoreOwnedCartAddAttribute(
      button,
      "aria-disabled",
      buttonState.ariaDisabled,
      "true"
    );
    restoreOwnedCartAddAttribute(
      button,
      "data-upv-cart-add-pending",
      buttonState.marker,
      token
    );
  });
  if (
    state.sourceButton &&
    state.sourceButton.getAttribute("data-upv-cart-add-loading") ===
      String(state.token)
  ) {
    if (
      !state.sourceHadLoading &&
      state.sourceButton.classList.contains("is-loading")
    ) {
      state.sourceButton.classList.remove("is-loading");
    }
    restoreOwnedCartAddAttribute(
      state.sourceButton,
      "data-upv-cart-add-loading",
      state.sourceLoadingMarker,
      String(state.token)
    );
  }
  state.buttonStates.length = 0;
  return true;
}

function installCartAddRepeatCaptureGuard() {
  if (
    typeof document === "undefined" ||
    !document.addEventListener
  ) return;
  if (
    cartAddLifecycle.captureGuard &&
    document.removeEventListener
  ) {
    document.removeEventListener(
      "click",
      cartAddLifecycle.captureGuard,
      true
    );
  }
  cartAddLifecycle.captureGuard = function (event) {
    var eventTarget = event && event.target;
    var addButton =
      eventTarget && typeof eventTarget.closest === "function"
        ? eventTarget.closest(".Sd_addProduct")
        : null;
    if (!addButton) return;
    var form = getCartAddFormElement(addButton);
    var state = getActiveCartAddState(form);
    if (!state) return;
    applyCartAddPendingState(state);
    event.preventDefault();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    } else if (typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }
  };
  document.addEventListener("click", cartAddLifecycle.captureGuard, true);
}

installCartAddRepeatCaptureGuard();

function restoreCartInteractionState() {
  $(".media-link, .cart-items-wrapper, [data-cart-items], tr.disabled")
    .removeClass("disabled");
}

function isCartMutationCheckoutBlocked() {
  var coordinator = window.UpvanityCartQuantityMutationCoordinator;
  var quantityStates = window.UpvanityCartQuantityMutations;
  var pageRender = window.UpvanityCartPageRenderLifecycle;
  var drawer = typeof document !== "undefined" && document.querySelector &&
    document.querySelector("[data-side-drawer]");
  var drawerOwner = drawer && drawer.upvCartDrawerOwnership;
  return !!(
    (quantityStates && quantityStates.size > 0) ||
    (coordinator && (coordinator.active ||
      (coordinator.externalQueue && coordinator.externalQueue.length > 0))) ||
    (pageRender && (pageRender.owner || pageRender.request ||
      pageRender.recovering)) ||
    (drawerOwner && drawerOwner.owner === "cart" &&
      isCartDrawerOwnershipCurrent(drawerOwner) && drawerOwner.renderRequest)
  );
}

function syncCartMutationCheckoutState() {
  var pending = isCartMutationCheckoutBlocked();
  if (typeof document !== "undefined" && document.documentElement) {
    if (pending) {
      document.documentElement.setAttribute("data-upv-cart-mutation-pending", "true");
    } else {
      document.documentElement.removeAttribute("data-upv-cart-mutation-pending");
    }
  }
  if (typeof cartNoteLifecycle !== "undefined" && cartNoteLifecycle &&
      typeof syncCartNoteCheckoutState === "function") {
    syncCartNoteCheckoutState();
  }
  var status = typeof document !== "undefined" && document.getElementById &&
    document.getElementById("UpvCartNoteGlobalStatus");
  if (!pending && status && status.textContent === window.upvCartUpdatingLabel) {
    status.textContent = "";
  }
  return pending;
}

function notifyCartRendered(cart) {
  if (!isValidCartDrawerServerSnapshot(cart) ||
      typeof cart.total_price !== "number" ||
      !document.dispatchEvent || typeof window.CustomEvent !== "function") return;
  document.dispatchEvent(new window.CustomEvent("upv:cart-rendered", {
    detail: { cart: cart }
  }));
}

function recoverUnverifiedCartMutation(drawerOwnership) {
  if (document.querySelector("[data-cart-wrapper]")) {
    recoverCartPageRenderFailure();
  } else if (isCartDrawerOwnershipCurrent(drawerOwnership)) {
    showCartDrawerFallback(drawerOwnership);
  }
  syncCartMutationCheckoutState();
}

var cartMutationFocusSelectors = {
  page: {
    image: ".cart-img",
    product: ".yv-product-title",
    decrement: ".line_item_change.quantity-down",
    quantity: '[name="updates[]"]',
    increment: ".line_item_change.quantity-up",
    remove: ".line_item_remove",
    gift: "#GiftWrapProduct",
    note: 'textarea[name="note"]',
    checkout: "#cartCheckout",
    continue: "a.btn[href]"
  },
  drawer: {
    product: ".yv-product-title",
    decrement: ".ajaxcart__qty--minus",
    quantity: ".ajaxcart__qty-num",
    increment: ".ajaxcart__qty--plus",
    remove: ".sd_mini_removeproduct",
    gift: "#GiftWrapProduct",
    noteToggle: ".cartDrawerNote",
    note: "#CartDrawer-note",
    checkout: ".checkout-btn",
    continue: ".shopping_cont"
  }
};

function isCartMutationSurfaceRole(role) {
  return (
    role === "gift" ||
    role === "noteToggle" ||
    role === "note" ||
    role === "checkout" ||
    role === "continue" ||
    role === "context" ||
    role === "surface"
  );
}

function getCartMutationControlRole(element, surface) {
  var selectors = cartMutationFocusSelectors[surface];
  if (!element || !selectors || typeof element.matches !== "function") {
    return null;
  }
  var roles = [
    "image",
    "product",
    "decrement",
    "quantity",
    "increment",
    "remove",
    "gift",
    "noteToggle",
    "note",
    "checkout",
    "continue"
  ];
  for (var index = 0; index < roles.length; index += 1) {
    var role = roles[index];
    if (selectors[role] && element.matches(selectors[role])) return role;
  }
  return null;
}

function captureCartMutationFocus(element, surface) {
  var role = getCartMutationControlRole(element, surface);
  if (!role || !element || typeof element.closest !== "function") return null;
  var surfaceRoot =
    surface === "drawer"
      ? element.closest("[data-side-drawer]")
      : element.closest("[data-cart-wrapper]");
  if (!surfaceRoot || typeof surfaceRoot.querySelectorAll !== "function") {
    return null;
  }
  var itemRoot = element.closest("[data-cart-item-key]");
  var itemRoots = surfaceRoot.querySelectorAll("[data-cart-item-key]");
  var itemIndex = -1;
  if (itemRoot) {
    for (var index = 0; index < itemRoots.length; index += 1) {
      if (itemRoots[index] === itemRoot) {
        itemIndex = index;
        break;
      }
    }
  } else if (!isCartMutationSurfaceRole(role)) {
    return null;
  }
  return {
    hadFocus: document.activeElement === element,
    itemIndex: itemIndex,
    itemKey: itemRoot ? itemRoot.getAttribute("data-cart-item-key") : null,
    role: role,
    sequence: null,
    sourceElement: element,
    surface: surface,
    surfaceRoot: surfaceRoot
  };
}

function assignCartMutationFocusSequence(focusIntent, mutationState) {
  if (
    focusIntent &&
    mutationState &&
    typeof mutationState.sequence === "number"
  ) {
    focusIntent.sequence = mutationState.sequence;
  }
  return focusIntent;
}

function isCartDrawerOpen() {
  return !!(
    document.body &&
    document.body.classList &&
    (document.body.classList.contains("side_Drawer_open") ||
      document.body.classList.contains("yv_side_Drawer_open"))
  );
}

function captureCartMutationContextFocus(element, surface, surfaceRoot) {
  if (
    !element ||
    !surfaceRoot ||
    typeof element.closest !== "function" ||
    typeof surfaceRoot.querySelectorAll !== "function"
  ) return null;
  var itemRoot = element.closest("[data-cart-item-key]");
  var itemRoots = surfaceRoot.querySelectorAll("[data-cart-item-key]");
  var itemIndex = -1;
  if (itemRoot) {
    for (var index = 0; index < itemRoots.length; index += 1) {
      if (itemRoots[index] === itemRoot) {
        itemIndex = index;
        break;
      }
    }
  }
  var contextId =
    !itemRoot && element.getAttribute
      ? element.getAttribute("id")
      : null;
  var contextName =
    !itemRoot && element.getAttribute
      ? element.getAttribute("name")
      : null;
  var contextTag =
    !itemRoot && element.tagName
      ? String(element.tagName).toLowerCase()
      : null;
  var contextRegion =
    !itemRoot && element.closest(".additional-checkout-buttons")
      ? "additionalCheckout"
      : null;
  return {
    contextId: contextId,
    contextName: contextName,
    contextRegion: contextRegion,
    contextTag: contextTag,
    hadFocus: true,
    itemIndex: itemIndex,
    itemKey: itemRoot ? itemRoot.getAttribute("data-cart-item-key") : null,
    role: itemRoot ? "product" : "context",
    sequence: null,
    sourceElement: element,
    surface: surface,
    surfaceRoot: surfaceRoot
  };
}

function isCartMutationFocusIntentCurrent(
  focusIntent,
  surfaceRoot,
  batchResult
) {
  if (
    !focusIntent ||
    !surfaceRoot ||
    focusIntent.surfaceRoot !== surfaceRoot ||
    !focusIntent.sourceElement ||
    focusIntent.sourceElement.isConnected === false
  ) return false;
  if (
    typeof focusIntent.sequence === "number" &&
    batchResult &&
    typeof batchResult.latestSequence === "number" &&
    focusIntent.sequence !== batchResult.latestSequence
  ) return false;
  if (
    focusIntent.surface === "drawer" &&
    !isCartDrawerOpen()
  ) return false;
  return true;
}

function resolveCartMutationFocusIntent(
  focusIntent,
  surfaceRoot,
  replacementRoot,
  batchResult
) {
  if (
    !isCartMutationFocusIntentCurrent(
      focusIntent,
      surfaceRoot,
      batchResult
    )
  ) return null;
  var activeElement = document.activeElement;
  if (activeElement === focusIntent.sourceElement) return focusIntent;
  if (
    focusIntent.role === "gift" &&
    focusIntent.hadFocus &&
    focusIntent.sourceElement.disabled &&
    (activeElement === document.body ||
      activeElement === document.documentElement)
  ) return focusIntent;
  if (
    !replacementRoot ||
    typeof replacementRoot.contains !== "function" ||
    !replacementRoot.contains(activeElement)
  ) return null;
  var activeIntent = captureCartMutationFocus(
    activeElement,
    focusIntent.surface
  );
  if (!activeIntent) {
    activeIntent = captureCartMutationContextFocus(
      activeElement,
      focusIntent.surface,
      surfaceRoot
    );
  }
  if (!activeIntent || activeIntent.surfaceRoot !== surfaceRoot) return null;
  activeIntent.sequence = focusIntent.sequence;
  return activeIntent;
}

function shouldRestoreCartMutationFocus(
  focusIntent,
  surfaceRoot,
  batchResult,
  replacementRoot
) {
  return !!resolveCartMutationFocusIntent(
    focusIntent,
    surfaceRoot,
    replacementRoot || surfaceRoot,
    batchResult
  );
}

function refreshCartDrawerFocusRotation(drawer) {
  if (
    !drawer ||
    !isCartDrawerOpen() ||
    typeof focusElementsRotation !== "function"
  ) return;
  focusElementsRotation($(drawer));
}

function findCartMutationItemByKey(itemRoots, itemKey) {
  if (!itemKey) return null;
  for (var index = 0; index < itemRoots.length; index += 1) {
    if (itemRoots[index].getAttribute("data-cart-item-key") === itemKey) {
      return itemRoots[index];
    }
  }
  return null;
}

function findCartMutationRoleTarget(itemRoot, surface, role) {
  var selectors = cartMutationFocusSelectors[surface];
  if (!itemRoot || !selectors || !selectors[role]) return null;
  return itemRoot.querySelector(selectors[role]);
}

function findCartMutationContextTarget(surfaceRoot, focusIntent) {
  if (
    !surfaceRoot ||
    !focusIntent ||
    typeof surfaceRoot.querySelectorAll !== "function"
  ) return null;
  var candidates;
  var index;
  if (focusIntent.contextId) {
    candidates = surfaceRoot.querySelectorAll("[id]");
    for (index = 0; index < candidates.length; index += 1) {
      if (
        candidates[index].getAttribute &&
        candidates[index].getAttribute("id") === focusIntent.contextId
      ) return candidates[index];
    }
  }
  if (focusIntent.contextName) {
    candidates = surfaceRoot.querySelectorAll("[name]");
    for (index = 0; index < candidates.length; index += 1) {
      if (
        candidates[index].getAttribute &&
        candidates[index].getAttribute("name") === focusIntent.contextName &&
        (!focusIntent.contextTag ||
          String(candidates[index].tagName || "").toLowerCase() ===
            focusIntent.contextTag)
      ) return candidates[index];
    }
  }
  if (focusIntent.contextRegion === "additionalCheckout") {
    candidates = surfaceRoot.querySelectorAll(
      ".additional-checkout-buttons, " +
        ".additional-checkout-buttons button, " +
        ".additional-checkout-buttons a[href], " +
        ".additional-checkout-buttons iframe, " +
        ".additional-checkout-buttons [tabindex], " +
        ".additional-checkout-buttons shopify-accelerated-checkout-cart"
    );
    for (index = 0; index < candidates.length; index += 1) {
      if (
        !focusIntent.contextTag ||
        String(candidates[index].tagName || "").toLowerCase() ===
          focusIntent.contextTag
      ) return candidates[index];
    }
  }
  return null;
}

function revealCartDrawerNoteForFocus(surfaceRoot) {
  if (!surfaceRoot || typeof surfaceRoot.querySelector !== "function") {
    return;
  }
  var toggle = surfaceRoot.querySelector(".cartDrawerNote");
  var container = surfaceRoot.querySelector("#CartDrawerNoteContainer");
  if (toggle) {
    if (toggle.classList) toggle.classList.add("active");
    if (toggle.setAttribute) toggle.setAttribute("aria-expanded", "true");
  }
  if (container) {
    if (container.setAttribute) container.setAttribute("aria-hidden", "false");
    if (container.style) container.style.display = "block";
  }
}

function isCartMutationFocusTargetUsable(target) {
  return !!(
    target &&
    typeof target.focus === "function" &&
    target.disabled !== true &&
    target.isConnected !== false &&
    (!target.getAttribute || target.getAttribute("aria-disabled") !== "true") &&
    (!target.closest || !target.closest("[inert]"))
  );
}

function focusCartMutationTarget(target) {
  if (!isCartMutationFocusTargetUsable(target)) return false;
  try {
    target.focus({ preventScroll: true });
  } catch (error) {
    try {
      target.focus();
    } catch (fallbackError) {
      return false;
    }
  }
  return document.activeElement === target;
}

function getCartMutationFallback(surfaceRoot, surface, role, excludeTarget) {
  if (!surfaceRoot || typeof surfaceRoot.querySelector !== "function") {
    return null;
  }
  var selectors =
    surface === "drawer"
      ? role === "note"
        ? [
            ".cartDrawerNote",
            ".yv_side_drawer_close",
            ".checkout-btn",
            ".shopping_cont",
            "button:not([disabled]), a[href], input:not([disabled]), " +
              "textarea:not([disabled])"
          ]
        : [
            ".emptySideCart a[href]",
            "[data-drawer-body] a.button[href]",
            ".yv_side_drawer_close",
            ".checkout-btn",
            ".shopping_cont",
            "button:not([disabled]), a[href], input:not([disabled]), " +
              "textarea:not([disabled])"
          ]
      : role === "gift"
        ? [
            "#cartCheckout",
            "a.btn[href]",
            "button:not([disabled]), a[href], input:not([disabled]), " +
              "textarea:not([disabled])"
          ]
        : [
            "[data-cart-empty] a[href]",
            "a.btn[href]",
            "#cartCheckout",
            "button:not([disabled]), a[href], input:not([disabled]), " +
              "textarea:not([disabled])"
          ];
  for (var index = 0; index < selectors.length; index += 1) {
    var target = surfaceRoot.querySelector(selectors[index]);
    if (
      target !== excludeTarget &&
      isCartMutationFocusTargetUsable(target)
    ) return target;
  }
  return null;
}

function restoreCartMutationFocus(focusIntent, surfaceRoot) {
  if (!focusIntent || !surfaceRoot) return false;
  var selectors = cartMutationFocusSelectors[focusIntent.surface];
  if (!selectors) return false;
  if (focusIntent.surface === "drawer" && focusIntent.role === "note") {
    revealCartDrawerNoteForFocus(surfaceRoot);
  }
  var itemRoots = surfaceRoot.querySelectorAll("[data-cart-item-key]");
  var sameItem = findCartMutationItemByKey(itemRoots, focusIntent.itemKey);
  var target =
    focusIntent.role === "context"
      ? findCartMutationContextTarget(surfaceRoot, focusIntent)
      : sameItem
        ? findCartMutationRoleTarget(
            sameItem,
            focusIntent.surface,
            focusIntent.role
          )
        : null;
  if (
    !target &&
    isCartMutationSurfaceRole(focusIntent.role) &&
    selectors[focusIntent.role]
  ) {
    target = surfaceRoot.querySelector(selectors[focusIntent.role]);
  }
  if (!isCartMutationFocusTargetUsable(target)) target = null;
  if (
    !target &&
    focusIntent.role === "context" &&
    focusIntent.contextRegion === "additionalCheckout"
  ) {
    target = surfaceRoot.querySelector("#cartCheckout");
    if (!isCartMutationFocusTargetUsable(target)) target = null;
  }
  if (!target && !sameItem && itemRoots.length > 0) {
    var nextIndex = Math.min(
      Math.max(focusIntent.itemIndex, 0),
      itemRoots.length - 1
    );
    target = findCartMutationRoleTarget(
      itemRoots[nextIndex],
      focusIntent.surface,
      focusIntent.role
    );
    if (!isCartMutationFocusTargetUsable(target)) target = null;
    if (!target && nextIndex > 0) {
      target = findCartMutationRoleTarget(
        itemRoots[nextIndex - 1],
        focusIntent.surface,
        focusIntent.role
      );
      if (!isCartMutationFocusTargetUsable(target)) target = null;
    }
  }
  if (!target) {
    if (
      focusIntent.surface === "drawer" &&
      focusIntent.role === "note"
    ) {
      target = surfaceRoot.querySelector(".cartDrawerNote");
      if (!isCartMutationFocusTargetUsable(target)) target = null;
    }
  }
  if (!target) {
    target = getCartMutationFallback(
      surfaceRoot,
      focusIntent.surface,
      focusIntent.role
    );
  }
  if (focusCartMutationTarget(target)) return true;
  return focusCartMutationTarget(
    getCartMutationFallback(
      surfaceRoot,
      focusIntent.surface,
      focusIntent.role,
      target
    )
  );
}

function markDeferredCartMutationFocus(focusIntent) {
  if (
    !focusIntent ||
    focusIntent.role !== "gift" ||
    focusIntent.deferUntilEnabled !== true
  ) return false;
  focusIntent.restoreAfterEnable = true;
  return true;
}

function restoreCartMutationFocusAfterRender(focusIntent, surfaceRoot) {
  if (markDeferredCartMutationFocus(focusIntent)) return false;
  return restoreCartMutationFocus(focusIntent, surfaceRoot);
}

function getGiftWrapMutationSurfaceRoot(surface, drawerOwnership) {
  if (surface === "drawer") {
    if (
      !isCartDrawerOwnershipCurrent(drawerOwnership) ||
      !isCartDrawerOpen()
    ) return null;
    return drawerOwnership.drawer;
  }
  return document.querySelector("[data-cart-wrapper]");
}

function announceGiftWrapMutationFailure(surfaceRoot, giftControl) {
  if (
    !surfaceRoot ||
    !giftControl ||
    !giftControl.closest ||
    !document.createElement
  ) return;
  var giftContainer = giftControl.closest(".giftcard-box");
  if (!giftContainer || !giftContainer.querySelector) return;
  var message = giftContainer.querySelector(".upv-gift-wrap-error");
  if (!message) {
    message = document.createElement("div");
    message.className = "cart-item-error error-text upv-gift-wrap-error";
    message.setAttribute("role", "alert");
    giftContainer.appendChild(message);
  }
  message.textContent = errorLabel;
}

function restoreDeferredGiftWrapMutationFocus(
  focusIntent,
  drawerOwnership
) {
  if (
    !focusIntent ||
    focusIntent.restoreAfterEnable !== true ||
    focusIntent.role !== "gift"
  ) return false;
  focusIntent.restoreAfterEnable = false;
  var surfaceRoot = getGiftWrapMutationSurfaceRoot(
    focusIntent.surface,
    drawerOwnership
  );
  if (!surfaceRoot || typeof surfaceRoot.querySelector !== "function") {
    return false;
  }
  var giftControl = surfaceRoot.querySelector(
    cartMutationFocusSelectors[focusIntent.surface].gift
  );
  if (!focusIntent.hadFocus) return false;
  var activeElement = document.activeElement;
  if (
    activeElement !== document.body &&
    activeElement !== document.documentElement &&
    activeElement !== focusIntent.sourceElement
  ) return false;
  return focusCartMutationTarget(giftControl);
}

function lockStaleGiftWrapControlAfterSuccess(control) {
  if (!control) return;
  control.checked = true;
  control.disabled = true;
  if (control.setAttribute) {
    control.setAttribute("aria-disabled", "true");
    control.setAttribute(
      "data-upv-gift-wrap-state",
      "stale-after-success"
    );
  }
}

function lockAllStaleGiftWrapControlsAfterSuccess() {
  if (!document.querySelectorAll) return;
  var controls = document.querySelectorAll("#GiftWrapProduct");
  for (var index = 0; index < controls.length; index += 1) {
    lockStaleGiftWrapControlAfterSuccess(controls[index]);
  }
}

function restoreGiftWrapMutationCompletionFocus(
  focusIntent,
  drawerOwnership,
  writeSucceeded,
  surface
) {
  var resolvedSurface = focusIntent ? focusIntent.surface : surface;
  var surfaceRoot = getGiftWrapMutationSurfaceRoot(
    resolvedSurface,
    drawerOwnership
  );
  if (writeSucceeded === true) {
    lockAllStaleGiftWrapControlsAfterSuccess();
  }
  if (
    writeSucceeded === false &&
    surfaceRoot &&
    typeof surfaceRoot.querySelector === "function"
  ) {
    announceGiftWrapMutationFailure(
      surfaceRoot,
      surfaceRoot.querySelector(
        cartMutationFocusSelectors[resolvedSurface].gift
      )
    );
  }
  if (
    writeSucceeded === true &&
    surfaceRoot &&
    typeof surfaceRoot.querySelector === "function"
  ) {
    var staleGiftControl = surfaceRoot.querySelector(
      cartMutationFocusSelectors[resolvedSurface].gift
    );
    if (staleGiftControl) {
      lockStaleGiftWrapControlAfterSuccess(staleGiftControl);
      if (!focusIntent || !focusIntent.hadFocus) return false;
      var activeElement = document.activeElement;
      if (
        activeElement !== document.body &&
        activeElement !== document.documentElement &&
        activeElement !== focusIntent.sourceElement
      ) return false;
      return focusCartMutationTarget(
        getCartMutationFallback(
          surfaceRoot,
          resolvedSurface,
          "gift",
          staleGiftControl
        )
      );
    }
  }
  if (
    focusIntent &&
    focusIntent.restoreFallbackAfterEnable === true &&
    surfaceRoot
  ) {
    focusIntent.restoreFallbackAfterEnable = false;
    var fallbackActiveElement = document.activeElement;
    if (
      fallbackActiveElement === document.body ||
      fallbackActiveElement === document.documentElement ||
      fallbackActiveElement === focusIntent.sourceElement
    ) {
      return focusCartMutationTarget(
        getCartMutationFallback(surfaceRoot, resolvedSurface, "gift")
      );
    }
  }
  return restoreDeferredGiftWrapMutationFocus(
    focusIntent,
    drawerOwnership
  );
}

function renderCartMutationFailures(batchResult, root) {
  if (
    !batchResult ||
    !Array.isArray(batchResult.failures) ||
    batchResult.failures.length === 0
  ) return;
  var searchRoot = root || document;
  var cartItems = searchRoot.querySelectorAll
    ? searchRoot.querySelectorAll("[data-cart-item-key]")
    : [];
  batchResult.failures.forEach(function (failure) {
    if (!failure || failure.type !== "quantity") return;
    var itemRoot = null;
    if (failure.itemKey) {
      for (var index = 0; index < cartItems.length; index += 1) {
        if (
          cartItems[index].getAttribute("data-cart-item-key") ===
          failure.itemKey
        ) {
          itemRoot = cartItems[index];
          break;
        }
      }
    }
    var errorElement =
      itemRoot && itemRoot.querySelector
        ? itemRoot.querySelector(
            '[id^="cartItemError-"], [id^="cartDrawerItemError-"]'
          )
        : null;
    if (!errorElement && failure.line && document.getElementById) {
      errorElement = document.getElementById(
        (root ? "cartDrawerItemError-" : "cartItemError-") + failure.line
      );
    }
    if (errorElement) errorElement.textContent = errorLabel;
  });
}

function requestCartQuantityChange(line, quantity, itemKey, callback) {
  var requestData = itemKey
    ? { id: itemKey, quantity: quantity }
    : { line: line, quantity: quantity };
  var settled = false;
  var settle = function (cart, succeeded) {
    if (settled) return;
    settled = true;
    callback(cart, succeeded);
  };
  try {
    jQuery.ajax({
      type: "POST",
      url: cartChangeUrl,
      data: requestData,
      dataType: "json",
      timeout: 12000,
      success: function (cart) {
        settle(cart, true);
      },
      error: function () {
        readCartAfterMutation(false, settle);
      }
    });
  } catch (error) {
    settle(null, false);
  }
}

function finishCartQuantityMutationBatch() {
  if (
    cartQuantityMutationCoordinator.active ||
    cartQuantityMutationStates.size > 0 ||
    cartQuantityMutationCoordinator.externalQueue.length > 0
  ) return;
  var latestCallback = cartQuantityMutationCoordinator.latestCallback;
  var lastCart = cartQuantityMutationCoordinator.lastCart;
  var allSucceeded = cartQuantityMutationCoordinator.allSucceeded;
  var latestSucceeded = cartQuantityMutationCoordinator.latestSucceeded;
  var latestSequence =
    cartQuantityMutationCoordinator.latestResultSequence;
  var failures = cartQuantityMutationCoordinator.failures.slice();
  var finalizers = cartQuantityMutationCoordinator.finalizers.slice();
  cartQuantityMutationCoordinator.latestCallback = null;
  cartQuantityMutationCoordinator.lastCart = null;
  cartQuantityMutationCoordinator.allSucceeded = true;
  cartQuantityMutationCoordinator.failures.length = 0;
  cartQuantityMutationCoordinator.finalizers.length = 0;
  cartQuantityMutationCoordinator.latestResultSequence = 0;
  cartQuantityMutationCoordinator.latestSucceeded = true;
  var finalized = false;
  var finalizerTimer = null;
  var runFinalizers = function () {
    if (finalized) return;
    finalized = true;
    if (finalizerTimer) clearTimeout(finalizerTimer);
    finalizerTimer = null;
    finalizers.forEach(function (finalizer) {
      if (typeof finalizer !== "function") return;
      try {
        finalizer();
      } catch (error) {}
    });
  };
  var renderRequest = null;
  if (typeof latestCallback === "function") {
    try {
      renderRequest = latestCallback(lastCart, latestSucceeded, {
        allSucceeded: allSucceeded,
        failures: failures,
        latestSequence: latestSequence
      });
    } catch (error) {
      try {
        restoreCartInteractionState();
      } catch (restoreError) {}
      runFinalizers();
      syncCartMutationCheckoutState();
      return;
    }
  }
  if (renderRequest && typeof renderRequest.always === "function") {
    finalizerTimer = setTimeout(runFinalizers, 12000);
    try {
      renderRequest.always(runFinalizers);
    } catch (error) {}
  } else {
    runFinalizers();
  }
  syncCartMutationCheckoutState();
}

function getNextCartQuantityMutation() {
  var nextMutation = null;
  cartQuantityMutationStates.forEach(function (state, stateKey) {
    if (!state || state.inFlight) return;
    if (
      !nextMutation ||
      state.sequence < nextMutation.sequence
    ) {
      nextMutation = {
        ready: state.ready,
        sequence: state.sequence,
        stateKey: stateKey,
        state: state,
        type: "quantity"
      };
    }
  });
  cartQuantityMutationCoordinator.externalQueue.forEach(function (task) {
    if (!task) return;
    if (!nextMutation || task.sequence < nextMutation.sequence) {
      nextMutation = {
        ready: true,
        sequence: task.sequence,
        task: task,
        type: "external"
      };
    }
  });
  return nextMutation && nextMutation.ready ? nextMutation : null;
}

function hasQueuedExternalMutationBetween(startSequence, endSequence) {
  return cartQuantityMutationCoordinator.externalQueue.some(function (task) {
    return (
      task &&
      task.affectsQuantity !== false &&
      task.sequence > startSequence &&
      task.sequence < endSequence
    );
  });
}

function runNextCartQuantityMutation() {
  if (cartQuantityMutationCoordinator.active) return;
  var nextMutation = getNextCartQuantityMutation();
  if (!nextMutation) {
    finishCartQuantityMutationBatch();
    return;
  }
  if (nextMutation.type === "external") {
    var externalTask = nextMutation.task;
    var externalIndex =
      cartQuantityMutationCoordinator.externalQueue.indexOf(externalTask);
    if (externalIndex < 0) {
      runNextCartQuantityMutation();
      return;
    }
    cartQuantityMutationCoordinator.externalQueue.splice(externalIndex, 1);
    cartQuantityMutationCoordinator.active = true;
    cartQuantityMutationCoordinator.activeState = externalTask;
    var externalSettled = false;
    var settleExternalTask = function (cart, succeeded) {
      if (externalSettled) return;
      externalSettled = true;
      cartQuantityMutationCoordinator.active = false;
      cartQuantityMutationCoordinator.activeState = null;
      if (externalTask.affectsRender !== false) {
        cartQuantityMutationCoordinator.lastCart = cart || null;
        cartQuantityMutationCoordinator.allSucceeded =
          cartQuantityMutationCoordinator.allSucceeded && succeeded;
        if (!succeeded) {
          cartQuantityMutationCoordinator.failures.push({
            sequence: externalTask.sequence,
            type: "external"
          });
        }
        if (
          externalTask.sequence >=
          cartQuantityMutationCoordinator.latestResultSequence
        ) {
          cartQuantityMutationCoordinator.latestResultSequence =
            externalTask.sequence;
          cartQuantityMutationCoordinator.latestSucceeded = succeeded;
        }
      }
      runNextCartQuantityMutation();
    };
    try {
      externalTask.execute(settleExternalTask);
    } catch (error) {
      settleExternalTask(null, false);
    }
    return;
  }
  var stateKey = nextMutation.stateKey;
  var state = nextMutation.state;
  if (cartQuantityMutationStates.get(stateKey) !== state) {
    runNextCartQuantityMutation();
    return;
  }
  cartQuantityMutationCoordinator.active = true;
  cartQuantityMutationCoordinator.activeState = state;
  state.inFlight = true;
  state.ready = false;
  var sentGeneration = state.generation;
  var sentQuantity = state.quantity;
  var sentSequence = state.sequence;
  requestCartQuantityChange(
    state.line,
    sentQuantity,
    state.itemKey,
    function (cart, succeeded) {
      cartQuantityMutationCoordinator.active = false;
      cartQuantityMutationCoordinator.activeState = null;
      cartQuantityMutationCoordinator.lastCart = cart || null;
      if (cartQuantityMutationStates.get(stateKey) !== state) {
        runNextCartQuantityMutation();
        return;
      }
      state.inFlight = false;
      var needsRetry =
        state.generation !== sentGeneration &&
        (!succeeded ||
          state.quantity !== sentQuantity ||
          hasQueuedExternalMutationBetween(sentSequence, state.sequence));
      if (needsRetry) {
        if (!state.timer) {
          state.ready = true;
          state.readySequence = state.sequence;
        }
      } else {
        if (state.timer) clearTimeout(state.timer);
        state.timer = null;
        cartQuantityMutationStates.delete(stateKey);
        cartQuantityMutationCoordinator.allSucceeded =
          cartQuantityMutationCoordinator.allSucceeded && succeeded;
        if (!succeeded) {
          cartQuantityMutationCoordinator.failures.push({
            itemKey: state.itemKey,
            line: state.line,
            sequence: state.sequence,
            type: "quantity"
          });
        }
        if (
          state.sequence >=
          cartQuantityMutationCoordinator.latestResultSequence
        ) {
          cartQuantityMutationCoordinator.latestResultSequence =
            state.sequence;
          cartQuantityMutationCoordinator.latestSucceeded = succeeded;
        }
      }
      runNextCartQuantityMutation();
    }
  );
}

function queueCartQuantityChange(line, quantity, itemKey, callback) {
  var stateKey = itemKey ? "key:" + itemKey : "line:" + line;
  var state = cartQuantityMutationStates.get(stateKey);
  if (!state) {
    state = {
      generation: 0,
      inFlight: false,
      itemKey: itemKey || null,
      line: line,
      quantity: quantity,
      ready: false,
      readySequence: 0,
      sequence: 0,
      timer: null
    };
    cartQuantityMutationStates.set(stateKey, state);
  }
  cartQuantityMutationCoordinator.latestCallback = callback;
  cartQuantityMutationCoordinator.sequence += 1;
  state.generation += 1;
  state.itemKey = itemKey || null;
  state.line = line;
  state.quantity = quantity;
  state.ready = false;
  state.sequence = cartQuantityMutationCoordinator.sequence;
  if (state.timer) clearTimeout(state.timer);
  state.timer = setTimeout(function () {
    if (cartQuantityMutationStates.get(stateKey) !== state) return;
    state.timer = null;
    state.ready = true;
    state.readySequence = state.sequence;
    runNextCartQuantityMutation();
  }, 250);
  syncCartMutationCheckoutState();
  return state;
}

function queueExternalCartMutation(execute, callback, finalizer, options) {
  if (typeof execute !== "function") return null;
  cartQuantityMutationCoordinator.sequence += 1;
  var task = {
    affectsQuantity: !options || options.affectsQuantity !== false,
    affectsRender: !options || options.affectsRender !== false,
    execute: execute,
    sequence: cartQuantityMutationCoordinator.sequence
  };
  if (typeof callback === "function") {
    cartQuantityMutationCoordinator.latestCallback = callback;
  }
  cartQuantityMutationCoordinator.externalQueue.push(task);
  if (typeof finalizer === "function") {
    cartQuantityMutationCoordinator.finalizers.push(finalizer);
  }
  syncCartMutationCheckoutState();
  runNextCartQuantityMutation();
  return task;
}

function deferCartReadUntilMutationsSettle(callback) {
  var mutationsPending =
    cartQuantityMutationCoordinator.active ||
    cartQuantityMutationStates.size > 0 ||
    cartQuantityMutationCoordinator.externalQueue.length > 0;
  if (!mutationsPending) return false;
  cartQuantityMutationCoordinator.latestCallback = callback;
  return true;
}

function readCartAfterMutation(succeeded, callback) {
  var settled = false;
  var snapshotRequest = null;
  var snapshotTimer = null;
  var settle = function (cart, snapshotSucceeded) {
    if (settled) return;
    settled = true;
    if (snapshotTimer) clearTimeout(snapshotTimer);
    snapshotTimer = null;
    callback(cart, succeeded && snapshotSucceeded);
  };
  snapshotTimer = setTimeout(function () {
    var timedOutRequest = snapshotRequest;
    settle(null, false);
    if (timedOutRequest && typeof timedOutRequest.abort === "function") {
      try {
        timedOutRequest.abort("timeout");
      } catch (error) {}
    }
  }, 5000);
  try {
    snapshotRequest = jQuery.getJSON(cartUrl, function (cart) {
      settle(cart, true);
    });
  } catch (error) {
    settle(null, false);
    return null;
  }
  if (snapshotRequest && typeof snapshotRequest.fail === "function") {
    snapshotRequest.fail(function () {
      settle(null, false);
    });
  }
  return snapshotRequest;
}

function continueExternalCartMutation(
  succeeded,
  sideEffect,
  callback,
  options
) {
  try {
    if (typeof sideEffect === "function") sideEffect();
  } catch (error) {}
  if (
    succeeded &&
    options &&
    options.deferSnapshotToDrawerRender === true
  ) {
    var shouldDeferSnapshot = true;
    if (typeof options.shouldDeferSnapshot === "function") {
      try {
        shouldDeferSnapshot = options.shouldDeferSnapshot() === true;
      } catch (error) {
        shouldDeferSnapshot = false;
      }
    }
    if (shouldDeferSnapshot) {
      callback(null, true);
      return null;
    }
  }
  return readCartAfterMutation(succeeded, callback);
}

function getCartRequestErrorMessage(xhr) {
  var response = xhr && xhr.responseJSON;
  if (response) {
    if (typeof response.description === "string" && response.description) {
      return response.description;
    }
    if (typeof response.message === "string" && response.message) {
      return response.message;
    }
    var errors = response.errors;
    if (typeof errors === "string" && errors) return errors;
    if (Array.isArray(errors) && errors.length) return errors.join(", ");
    if (errors && typeof errors === "object") {
      var errorKeys = Object.keys(errors);
      if (errorKeys.length) {
        var errorKey = errorKeys[0];
        var errorValue = errors[errorKey];
        if (Array.isArray(errorValue)) errorValue = errorValue.join(", ");
        if (typeof errorValue === "string" && errorValue) {
          return errorKey + " " + errorValue;
        }
      }
    }
  }
  return typeof errorLabel === "string" && errorLabel ? errorLabel : "Error";
}

function getCartAddErrorElement(formElement, sourceButton) {
  var sourceRoot =
    sourceButton && typeof sourceButton.closest === "function"
      ? sourceButton.closest("#yvProductStickyBar, .quick-add-popup")
      : null;
  var errorElement =
    sourceRoot && typeof sourceRoot.querySelector === "function"
      ? sourceRoot.querySelector(".productErrors")
      : null;
  if (
    !errorElement &&
    formElement &&
    typeof formElement.querySelector === "function"
  ) {
    errorElement = formElement.querySelector(".productErrors");
  }
  if (
    !errorElement &&
    formElement &&
    document.createElement
  ) {
    errorElement = document.createElement("div");
    errorElement.className = "productErrors error-text upv-cart-add-error";
    errorElement.style.display = "none";
    if (
      sourceButton &&
      sourceButton.parentNode &&
      typeof sourceButton.parentNode.insertBefore === "function"
    ) {
      sourceButton.parentNode.insertBefore(errorElement, sourceButton);
    } else if (typeof formElement.appendChild === "function") {
      formElement.appendChild(errorElement);
    } else {
      errorElement = null;
    }
  }
  if (errorElement && typeof errorElement.setAttribute === "function") {
    errorElement.setAttribute("role", "status");
  }
  return errorElement;
}

function getGlobalCartAddErrorElement() {
  var errorElement = document.getElementById
    ? document.getElementById("upv-cart-add-global-error")
    : null;
  if (errorElement) return errorElement;
  if (!document.createElement || !document.body) return null;
  errorElement = document.createElement("div");
  errorElement.id = "upv-cart-add-global-error";
  errorElement.className = "yv-visually-hidden";
  errorElement.setAttribute("role", "alert");
  document.body.appendChild(errorElement);
  return errorElement;
}

function isCartAddErrorElementAvailable(errorElement) {
  if (!errorElement || errorElement.isConnected === false) return false;
  if (typeof errorElement.closest !== "function") return true;
  var quickAddPopup = errorElement.closest(".quick-add-popup");
  if (
    quickAddPopup &&
    !quickAddPopup.classList.contains("show")
  ) return false;
  var sharedDrawer = errorElement.closest("[data-side-drawer]");
  if (
    sharedDrawer &&
    document.body &&
    !document.body.classList.contains("side_Drawer_open") &&
    !document.body.classList.contains("yv_side_Drawer_open")
  ) return false;
  return true;
}

function resolveCartAddErrorElement(
  errorElement,
  formElement,
  sourceButton
) {
  if (isCartAddErrorElementAvailable(errorElement)) {
    return errorElement;
  }
  var currentForm = formElement;
  var formId = getCartAddFormId(formElement);
  if (formId && document.getElementById) {
    currentForm = document.getElementById(formId) || currentForm;
  }
  var currentSource =
    sourceButton && sourceButton.isConnected !== false
      ? sourceButton
      : currentForm && typeof currentForm.querySelector === "function"
        ? currentForm.querySelector(".Sd_addProduct")
        : null;
  var currentError = getCartAddErrorElement(currentForm, currentSource);
  if (isCartAddErrorElementAvailable(currentError)) {
    return currentError;
  }
  return getGlobalCartAddErrorElement();
}

function clearCartAddError(errorElement) {
  if (errorElement) {
    if (errorElement.upvCartAddAnnouncementTimer) {
      clearTimeout(errorElement.upvCartAddAnnouncementTimer);
    }
    errorElement.upvCartAddAnnouncementTimer = null;
    errorElement.upvCartAddAnnouncementToken =
      (errorElement.upvCartAddAnnouncementToken || 0) + 1;
    errorElement.textContent = "";
    if (errorElement.style) errorElement.style.display = "none";
  }
  var globalError = document.getElementById
    ? document.getElementById("upv-cart-add-global-error")
    : null;
  if (globalError && globalError !== errorElement) {
    if (globalError.upvCartAddAnnouncementTimer) {
      clearTimeout(globalError.upvCartAddAnnouncementTimer);
    }
    globalError.upvCartAddAnnouncementTimer = null;
    globalError.upvCartAddAnnouncementToken =
      (globalError.upvCartAddAnnouncementToken || 0) + 1;
    globalError.textContent = "";
  }
}

function setCartAddErrorMessage(errorElement, message) {
  if (!errorElement) return;
  if (errorElement.id !== "upv-cart-add-global-error") {
    errorElement.textContent = message;
    return;
  }
  if (errorElement.upvCartAddAnnouncementTimer) {
    clearTimeout(errorElement.upvCartAddAnnouncementTimer);
  }
  errorElement.upvCartAddAnnouncementToken =
    (errorElement.upvCartAddAnnouncementToken || 0) + 1;
  var announcementToken = errorElement.upvCartAddAnnouncementToken;
  errorElement.textContent = "";
  errorElement.upvCartAddAnnouncementTimer = setTimeout(function () {
    if (
      errorElement.upvCartAddAnnouncementToken !== announcementToken ||
      errorElement.isConnected === false
    ) return;
    errorElement.upvCartAddAnnouncementTimer = null;
    errorElement.textContent = message;
  }, 0);
}

function isUncertainCartAddFailure(xhr, textStatus) {
  return (
    textStatus === "timeout" ||
    textStatus === "parsererror" ||
    !!(
      xhr &&
      typeof xhr.status === "number" &&
      (xhr.status === 0 || xhr.status >= 500)
    )
  );
}

function showUncertainCartAddError(
  errorElement,
  formElement,
  sourceButton
) {
  errorElement = resolveCartAddErrorElement(
    errorElement,
    formElement,
    sourceButton
  );
  if (!errorElement) return;
  setCartAddErrorMessage(
    errorElement,
    "We couldn't confirm whether this item was added. Please check your cart before trying again."
  );
  if (errorElement.style) errorElement.style.display = "";
}

function showAddToCartError(
  xhr,
  errorElement,
  formElement,
  sourceButton
) {
  errorElement = resolveCartAddErrorElement(
    errorElement,
    formElement,
    sourceButton
  );
  if (!errorElement) return;
  var response = xhr && xhr.responseJSON;
  var errors = response && response.errors;
  var giftCardWrapper =
    formElement && typeof formElement.querySelector === "function"
      ? formElement.querySelector("[data-gift-card-box]")
      : null;
  if (
    giftCardWrapper &&
    errors &&
    typeof errors === "object" &&
    errors.email
  ) {
    var giftCardEmail = giftCardWrapper.querySelector("[type=email]");
    var emailError = Array.isArray(errors.email)
      ? errors.email.join(", ")
      : String(errors.email);
    var emailLabel =
      giftCardEmail && giftCardEmail.getAttribute("data-attr") || "Email";
    setCartAddErrorMessage(
      errorElement,
      emailLabel + " " + emailError
    );
    if (errorElement.style) errorElement.style.display = "";
    return;
  }
  setCartAddErrorMessage(
    errorElement,
    getCartRequestErrorMessage(xhr)
  );
  if (errorElement.style) errorElement.style.display = "";
}

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function freeShippingBar(cart) {
  let countryAvailable = checkShippingAvailablity();
  let shippingBarContainer = $("[data-free-shipping-container]");
  if (countryAvailable && shippingBarContainer.length > 0) {
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      return false;
    }
    let cartPrice = cart.original_total_price;
    let shippending = Shopify.formatMoney(
      convertShippingAmount - cartPrice,
      moneyFormat
    );
    let shippingPercentage = parseFloat(
      (cartPrice * 100) / convertShippingAmount
    ).toFixed(2);
    if (shippingPercentage > 10 && shippingPercentage < 100) {
      shippingPercentage = shippingPercentage - 5;
    } else if (shippingPercentage > 100) {
      shippingPercentage = 100;
    }
    if ($("[data-free-shipping-text]").length > 0) {
      if (shippingPercentage >= 100) {
        $("[data-free-shipping-text]").text(freeShippingBarSuccessText);
      } else {
        $("[data-free-shipping-text]").text(
          freeShippingBarText.replace("||amount||", shippending)
        );
      }
    }

    if ($("[data-free-shipping-bar]").length > 0) {
      $("[data-free-shipping-bar]").css("width", shippingPercentage + "%");
    }
    shippingBarContainer.removeClass("hidden");
  }
}

var favicon = false;

function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  if (freeShippingBarStatus) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(freeShippingBarAmount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

var cartNoteControlSelector = "#Cart-note, #CartDrawer-note";
var cartNoteStandardCheckoutSelector =
  ".cart-btn-container .checkout-btn, #cartCheckout, " +
  'button[name="checkout"], input[name="checkout"]';
var cartNoteAcceleratedCheckoutSelector =
  "[data-cart-wrapper] [data-upv-cart-note-accelerated-host], " +
  "[data-cart-wrapper] shopify-accelerated-checkout-cart";
var cartNoteRequestTimeout = 12000;
var cartNoteRecoveryTimeout = 5000;
var cartNoteLifecycle =
  window.UpvanityCartNoteLifecycle &&
  typeof window.UpvanityCartNoteLifecycle === "object"
    ? window.UpvanityCartNoteLifecycle
    : {
        composingCount: 0,
        compositionOwner: null,
        confirmedValue: null,
        checkoutIntent: null,
        desiredValue: null,
        inFlight: false,
        lastSaveUncertain: false,
        lastSourceId: "",
        queued: false,
        request: null,
        retryAfterInFlight: false,
        revision: 0,
        sentRevision: 0,
        stateVersion: 0,
        timer: null
      };
window.UpvanityCartNoteLifecycle = cartNoteLifecycle;
if (!(cartNoteLifecycle.composingElements instanceof WeakSet)) {
  cartNoteLifecycle.composingElements = new WeakSet();
}
if (typeof cartNoteLifecycle.composingCount !== "number") {
  cartNoteLifecycle.composingCount = 0;
}
if (typeof cartNoteLifecycle.revision !== "number") {
  cartNoteLifecycle.revision = 0;
}
if (typeof cartNoteLifecycle.sentRevision !== "number") {
  cartNoteLifecycle.sentRevision = 0;
}
if (typeof cartNoteLifecycle.stateVersion !== "number") {
  cartNoteLifecycle.stateVersion = 0;
}
if (!(cartNoteLifecycle.acceleratedCheckoutStates instanceof Map)) {
  cartNoteLifecycle.acceleratedCheckoutStates = new Map();
}
if (!(cartNoteLifecycle.drawerCheckoutStates instanceof Map)) {
  cartNoteLifecycle.drawerCheckoutStates = new Map();
}
if (!(cartNoteLifecycle.pageCheckoutStates instanceof Map)) {
  cartNoteLifecycle.pageCheckoutStates = new Map();
}
if (typeof cartNoteLifecycle.lastSaveUncertain !== "boolean") {
  cartNoteLifecycle.lastSaveUncertain = false;
}

function normalizeCartNoteValue(value) {
  var normalized =
    value === null || typeof value === "undefined" ? "" : String(value);
  if (typeof normalized.toWellFormed === "function") {
    return normalized.toWellFormed();
  }
  var wellFormed = "";
  for (var index = 0; index < normalized.length; index += 1) {
    var codeUnit = normalized.charCodeAt(index);
    if (codeUnit >= 0xd800 && codeUnit <= 0xdbff) {
      var nextCodeUnit = normalized.charCodeAt(index + 1);
      if (nextCodeUnit >= 0xdc00 && nextCodeUnit <= 0xdfff) {
        wellFormed += normalized.charAt(index) + normalized.charAt(index + 1);
        index += 1;
      } else {
        wellFormed += "\ufffd";
      }
    } else if (codeUnit >= 0xdc00 && codeUnit <= 0xdfff) {
      wellFormed += "\ufffd";
    } else {
      wellFormed += normalized.charAt(index);
    }
  }
  return wellFormed;
}

function isCartNoteControl(element) {
  return !!(
    element &&
    typeof element.matches === "function" &&
    element.matches(cartNoteControlSelector)
  );
}

function releaseCartNoteComposition(control) {
  if (!control) return false;
  var wasComposing = cartNoteLifecycle.composingElements.has(control);
  if (wasComposing) {
    cartNoteLifecycle.composingElements.delete(control);
    cartNoteLifecycle.composingCount = Math.max(
      0,
      cartNoteLifecycle.composingCount - 1
    );
  }
  if (cartNoteLifecycle.compositionOwner === control) {
    cartNoteLifecycle.compositionOwner = null;
  }
  return wasComposing;
}

function reconcileCartNoteComposition() {
  var owner = cartNoteLifecycle.compositionOwner;
  if (owner && owner.isConnected === false) {
    releaseCartNoteComposition(owner);
    return true;
  }
  if (!owner && cartNoteLifecycle.composingCount > 0) {
    cartNoteLifecycle.composingCount = 0;
    cartNoteLifecycle.composingElements = new WeakSet();
  }
  return false;
}

function getCartNoteControls(root) {
  var searchRoot = root || document;
  var controls = [];
  if (isCartNoteControl(searchRoot)) controls.push(searchRoot);
  if (searchRoot && typeof searchRoot.querySelectorAll === "function") {
    var descendants = searchRoot.querySelectorAll(cartNoteControlSelector);
    for (var index = 0; index < descendants.length; index += 1) {
      if (controls.indexOf(descendants[index]) < 0) {
        controls.push(descendants[index]);
      }
    }
  }
  return controls;
}

function getCartNoteLabel(control) {
  if (!control || !control.id || !document.querySelector) return "";
  var label = document.querySelector('label[for="' + control.id + '"]');
  return label && label.textContent ? label.textContent.trim() : "";
}

function ensureCartNoteStatus(control) {
  if (!control || !control.id || !document.createElement) return null;
  var statusId = control.id + "-status";
  var status = document.getElementById(statusId);
  var insertionParent = control.parentNode;
  var insertionReference = control.nextSibling;
  var collapsibleContainer =
    control.closest && control.closest("#CartDrawerNoteContainer");
  if (collapsibleContainer && collapsibleContainer.parentNode) {
    insertionParent = collapsibleContainer.parentNode;
    insertionReference = collapsibleContainer.nextSibling;
  }
  if (!status) {
    status = document.createElement("div");
    status.id = statusId;
    status.className = "visually-hidden upv-cart-note-status";
    status.setAttribute("data-upv-cart-note-status", "true");
    status.setAttribute("aria-live", "polite");
    status.setAttribute("aria-atomic", "true");
    status.setAttribute("role", "status");
  }
  if (
    insertionParent &&
    (status.parentNode !== insertionParent || insertionReference !== status)
  ) {
    insertionParent.insertBefore(status, insertionReference);
  }
  var describedBy = (control.getAttribute("aria-describedby") || "")
    .split(/\s+/)
    .filter(Boolean);
  if (describedBy.indexOf(statusId) < 0) {
    describedBy.push(statusId);
    control.setAttribute("aria-describedby", describedBy.join(" "));
  }
  return status;
}

function ensureGlobalCartNoteStatus() {
  if (!document.createElement || !document.body) return null;
  var status = document.getElementById("UpvCartNoteGlobalStatus");
  if (!status) {
    status = document.createElement("div");
    status.id = "UpvCartNoteGlobalStatus";
    status.className = "visually-hidden upv-cart-note-global-status";
    status.setAttribute("aria-live", "polite");
    status.setAttribute("aria-atomic", "true");
    status.setAttribute("role", "status");
    document.body.appendChild(status);
  }
  return status;
}

function readCartNoteOwnedAttribute(element, name) {
  return element && typeof element.getAttribute === "function"
    ? element.getAttribute(name)
    : null;
}

function restoreCartNoteOwnedAttribute(element, name, originalValue, ownedValue) {
  if (
    !element ||
    typeof element.getAttribute !== "function" ||
    typeof element.setAttribute !== "function" ||
    typeof element.removeAttribute !== "function" ||
    element.getAttribute(name) !== ownedValue
  ) return;
  if (originalValue === null) element.removeAttribute(name);
  else element.setAttribute(name, originalValue);
}

function getCartNoteAcceleratedHosts() {
  if (!document.querySelectorAll) return [];
  var markedHosts = document.querySelectorAll(
    "[data-cart-wrapper] [data-upv-cart-note-accelerated-host]"
  );
  if (markedHosts.length) return Array.prototype.slice.call(markedHosts);
  return Array.prototype.slice.call(
    document.querySelectorAll(
      "[data-cart-wrapper] shopify-accelerated-checkout-cart"
    )
  );
}

function applyCartNoteAcceleratedBlock(host) {
  if (!host || typeof host.setAttribute !== "function") return;
  var states = cartNoteLifecycle.acceleratedCheckoutStates;
  var state = states.get(host);
  if (!state) {
    var bootOwned =
      readCartNoteOwnedAttribute(host, "data-upv-cart-note-boot-lock") ===
      "true";
    state = {
      ariaDisabled: bootOwned
        ? null
        : readCartNoteOwnedAttribute(host, "aria-disabled"),
      bootOwned: bootOwned,
      hidden: readCartNoteOwnedAttribute(host, "hidden"),
      inert: bootOwned ? null : readCartNoteOwnedAttribute(host, "inert"),
      lockMarker: readCartNoteOwnedAttribute(
        host,
        "data-upv-cart-note-lock"
      ),
      usedHiddenFallback: false
    };
    states.set(host, state);
  } else {
    if (readCartNoteOwnedAttribute(host, "aria-disabled") !== "true") {
      state.ariaDisabled = readCartNoteOwnedAttribute(host, "aria-disabled");
    }
    if (readCartNoteOwnedAttribute(host, "inert") !== "") {
      state.inert = readCartNoteOwnedAttribute(host, "inert");
    }
    if (
      state.usedHiddenFallback &&
      readCartNoteOwnedAttribute(host, "hidden") !== ""
    ) {
      state.hidden = readCartNoteOwnedAttribute(host, "hidden");
    }
  }
  host.setAttribute("data-upv-cart-note-lock", "true");
  host.setAttribute("aria-disabled", "true");
  host.setAttribute("inert", "");
  if (!("inert" in host)) {
    host.setAttribute("hidden", "");
    state.usedHiddenFallback = true;
  }
}

function restoreCartNoteAcceleratedHost(host) {
  var states = cartNoteLifecycle.acceleratedCheckoutStates;
  var state = states.get(host);
  if (!state) return;
  var ownsLock =
    readCartNoteOwnedAttribute(host, "data-upv-cart-note-lock") === "true";
  if (!ownsLock) {
    states.delete(host);
    return;
  }
  restoreCartNoteOwnedAttribute(
    host,
    "aria-disabled",
    state.ariaDisabled,
    "true"
  );
  restoreCartNoteOwnedAttribute(host, "inert", state.inert, "");
  if (state.usedHiddenFallback) {
    restoreCartNoteOwnedAttribute(host, "hidden", state.hidden, "");
  }
  restoreCartNoteOwnedAttribute(
    host,
    "data-upv-cart-note-lock",
    state.lockMarker,
    "true"
  );
  if (
    state.bootOwned &&
    readCartNoteOwnedAttribute(host, "data-upv-cart-note-boot-lock") ===
      "true"
  ) {
    host.removeAttribute("data-upv-cart-note-boot-lock");
  }
  states.delete(host);
}

function getCartNoteDrawerCheckoutControls() {
  if (!document.querySelectorAll) return [];
  return Array.prototype.slice.call(
    document.querySelectorAll(".cart-btn-container .checkout-btn")
  );
}

function applyCartNoteDrawerCheckoutBlock(control) {
  if (!control || typeof control.setAttribute !== "function") return;
  var states = cartNoteLifecycle.drawerCheckoutStates;
  var state = states.get(control);
  if (!state) {
    state = {
      ariaDisabled: readCartNoteOwnedAttribute(control, "aria-disabled"),
      href: readCartNoteOwnedAttribute(control, "href"),
      marker: readCartNoteOwnedAttribute(
        control,
        "data-upv-cart-note-checkout-parked"
      ),
      role: readCartNoteOwnedAttribute(control, "role"),
      roleOwned: readCartNoteOwnedAttribute(control, "role") === null,
      tabIndex: readCartNoteOwnedAttribute(control, "tabindex")
    };
    states.set(control, state);
  } else {
    if (readCartNoteOwnedAttribute(control, "aria-disabled") !== "true") {
      state.ariaDisabled = readCartNoteOwnedAttribute(
        control,
        "aria-disabled"
      );
    }
    if (readCartNoteOwnedAttribute(control, "href") !== null) {
      state.href = readCartNoteOwnedAttribute(control, "href");
    }
    if (readCartNoteOwnedAttribute(control, "tabindex") !== "0") {
      state.tabIndex = readCartNoteOwnedAttribute(control, "tabindex");
    }
    if (
      state.roleOwned &&
      readCartNoteOwnedAttribute(control, "role") !== "link"
    ) {
      state.role = readCartNoteOwnedAttribute(control, "role");
      state.roleOwned = false;
    }
  }
  control.setAttribute("data-upv-cart-note-checkout-parked", "true");
  control.setAttribute("aria-disabled", "true");
  control.setAttribute("tabindex", "0");
  if (state.roleOwned) control.setAttribute("role", "link");
  if (typeof control.removeAttribute === "function") {
    control.removeAttribute("href");
  }
}

function restoreCartNoteDrawerCheckoutControl(control) {
  var states = cartNoteLifecycle.drawerCheckoutStates;
  var state = states.get(control);
  if (!state) return;
  if (
    readCartNoteOwnedAttribute(
      control,
      "data-upv-cart-note-checkout-parked"
    ) !== "true"
  ) {
    states.delete(control);
    return;
  }
  restoreCartNoteOwnedAttribute(
    control,
    "data-upv-cart-note-checkout-parked",
    state.marker,
    "true"
  );
  restoreCartNoteOwnedAttribute(
    control,
    "aria-disabled",
    state.ariaDisabled,
    "true"
  );
  restoreCartNoteOwnedAttribute(control, "tabindex", state.tabIndex, "0");
  if (state.roleOwned) {
    restoreCartNoteOwnedAttribute(control, "role", state.role, "link");
  }
  if (
    state.href !== null &&
    readCartNoteOwnedAttribute(control, "href") === null &&
    typeof control.setAttribute === "function"
  ) {
    control.setAttribute("href", state.href);
  }
  states.delete(control);
}

function getCartNotePageCheckoutControls() {
  if (!document.querySelectorAll) return [];
  return Array.prototype.slice.call(document.querySelectorAll("#cartCheckout"));
}

function applyCartNotePageCheckoutBlock(control) {
  if (!control || typeof control.setAttribute !== "function") return;
  var states = cartNoteLifecycle.pageCheckoutStates;
  var state = states.get(control);
  if (!state) {
    state = {
      ariaDisabled: readCartNoteOwnedAttribute(control, "aria-disabled"),
      marker: readCartNoteOwnedAttribute(
        control,
        "data-upv-cart-note-checkout-locked"
      )
    };
    states.set(control, state);
  } else if (
    readCartNoteOwnedAttribute(control, "aria-disabled") !== "true"
  ) {
    state.ariaDisabled = readCartNoteOwnedAttribute(control, "aria-disabled");
  }
  control.setAttribute("data-upv-cart-note-checkout-locked", "true");
  control.setAttribute("aria-disabled", "true");
}

function restoreCartNotePageCheckoutControl(control) {
  var states = cartNoteLifecycle.pageCheckoutStates;
  var state = states.get(control);
  if (!state) return;
  if (
    readCartNoteOwnedAttribute(
      control,
      "data-upv-cart-note-checkout-locked"
    ) !== "true"
  ) {
    states.delete(control);
    return;
  }
  restoreCartNoteOwnedAttribute(
    control,
    "data-upv-cart-note-checkout-locked",
    state.marker,
    "true"
  );
  restoreCartNoteOwnedAttribute(
    control,
    "aria-disabled",
    state.ariaDisabled,
    "true"
  );
  states.delete(control);
}

function isCartNoteCheckoutBlocked() {
  return !!(
    isCartNoteDirty() ||
    cartNoteLifecycle.timer ||
    cartNoteLifecycle.queued ||
    cartNoteLifecycle.inFlight ||
    cartNoteLifecycle.retryAfterInFlight ||
    cartNoteLifecycle.composingCount > 0 ||
    cartNoteLifecycle.compositionFlushPending ||
    cartNoteLifecycle.lastErrorMessage ||
    cartNoteLifecycle.lastSaveUncertain
  );
}

function announceCartNoteCheckoutStatus(message, alert) {
  var status = ensureGlobalCartNoteStatus();
  if (!status) return;
  status.className = "visually-hidden upv-cart-note-global-status";
  if (alert) {
    status.removeAttribute("aria-live");
    status.setAttribute("role", "alert");
  } else {
    status.setAttribute("aria-live", "polite");
    status.setAttribute("role", "status");
  }
  status.textContent = message;
}

function completeCartNoteCheckoutIntent() {
  var intent = cartNoteLifecycle.checkoutIntent;
  if (!intent) return;
  cartNoteLifecycle.checkoutIntent = null;
  var target = intent.target;
  if (target && target.isConnected === false) return;
  if (
    intent.surface === "drawer" &&
    typeof isCartDrawerOpen === "function" &&
    !isCartDrawerOpen()
  ) return;
  announceCartNoteCheckoutStatus(
    "Your note is saved. Select Checkout again to continue.",
    false
  );
}

function syncCartNoteCheckoutState() {
  var blocked = isCartNoteCheckoutBlocked();
  var controlsBlocked = blocked ||
    (typeof isCartMutationCheckoutBlocked === "function" &&
      isCartMutationCheckoutBlocked());
  if (document.documentElement) {
    if (blocked) {
      document.documentElement.setAttribute(
        "data-upv-cart-note-checkout-blocked",
        "true"
      );
    } else {
      document.documentElement.removeAttribute(
        "data-upv-cart-note-checkout-blocked"
      );
    }
  }

  var acceleratedHosts = getCartNoteAcceleratedHosts();
  cartNoteLifecycle.acceleratedCheckoutStates.forEach(function (_, host) {
    if (acceleratedHosts.indexOf(host) < 0) {
      restoreCartNoteAcceleratedHost(host);
    }
  });
  acceleratedHosts.forEach(function (host) {
    if (controlsBlocked) {
      applyCartNoteAcceleratedBlock(host);
      return;
    }
    if (
      !cartNoteLifecycle.acceleratedCheckoutStates.has(host) &&
      readCartNoteOwnedAttribute(
        host,
        "data-upv-cart-note-boot-lock"
      ) === "true"
    ) {
      applyCartNoteAcceleratedBlock(host);
    }
    restoreCartNoteAcceleratedHost(host);
  });

  var drawerControls = getCartNoteDrawerCheckoutControls();
  cartNoteLifecycle.drawerCheckoutStates.forEach(function (_, control) {
    if (drawerControls.indexOf(control) < 0) {
      restoreCartNoteDrawerCheckoutControl(control);
    }
  });
  drawerControls.forEach(function (control) {
    if (controlsBlocked) applyCartNoteDrawerCheckoutBlock(control);
    else restoreCartNoteDrawerCheckoutControl(control);
  });

  var pageControls = getCartNotePageCheckoutControls();
  cartNoteLifecycle.pageCheckoutStates.forEach(function (_, control) {
    if (pageControls.indexOf(control) < 0) {
      restoreCartNotePageCheckoutControl(control);
    }
  });
  pageControls.forEach(function (control) {
    if (controlsBlocked) applyCartNotePageCheckoutBlock(control);
    else restoreCartNotePageCheckoutControl(control);
  });

  if (!blocked) completeCartNoteCheckoutIntent();
  return blocked;
}

function setCartNoteControlsBusy(busy) {
  getCartNoteControls(document).forEach(function (control) {
    if (busy) control.setAttribute("aria-busy", "true");
    else control.removeAttribute("aria-busy");
  });
}

function clearCartNoteError() {
  cartNoteLifecycle.lastErrorMessage = "";
  getCartNoteControls(document).forEach(function (control) {
    control.removeAttribute("aria-invalid");
    control.removeAttribute("aria-errormessage");
    var status = ensureCartNoteStatus(control);
    if (!status) return;
    status.className = "visually-hidden upv-cart-note-status";
    status.setAttribute("aria-live", "polite");
    status.setAttribute("role", "status");
    status.textContent = "";
  });
  var globalStatus = document.getElementById("UpvCartNoteGlobalStatus");
  if (globalStatus) {
    globalStatus.className = "visually-hidden upv-cart-note-global-status";
    globalStatus.setAttribute("aria-live", "polite");
    globalStatus.setAttribute("role", "status");
    globalStatus.textContent = "";
  }
}

function appendCartNoteErrorActions(status) {
  if (
    !status ||
    typeof status.appendChild !== "function" ||
    !document.createElement
  ) return;
  var actions = document.createElement("div");
  actions.className = "upv-cart-note-actions";
  if (cartNoteLifecycle.lastSaveUncertain) {
    var reloadButton = document.createElement("button");
    reloadButton.type = "button";
    reloadButton.className = "upv-cart-note-action";
    reloadButton.setAttribute("data-upv-cart-note-reload", "true");
    reloadButton.textContent = "Reload cart to verify";
    actions.appendChild(reloadButton);
  } else {
    var retryButton = document.createElement("button");
    retryButton.type = "button";
    retryButton.className = "upv-cart-note-action";
    retryButton.setAttribute("data-upv-cart-note-retry", "true");
    retryButton.textContent = "Retry note save";
    actions.appendChild(retryButton);
    var clearButton = document.createElement("button");
    clearButton.type = "button";
    clearButton.className = "upv-cart-note-action";
    clearButton.setAttribute("data-upv-cart-note-clear", "true");
    clearButton.textContent = "Clear note";
    actions.appendChild(clearButton);
  }
  status.appendChild(actions);
}

function showCartNoteError(xhr, announce) {
  var message = getCartRequestErrorMessage(xhr);
  cartNoteLifecycle.lastErrorMessage = message;
  var guidance = cartNoteLifecycle.lastSaveUncertain
    ? " We could not verify whether the note reached the cart. Checkout " +
      "remains paused; reload the cart before continuing."
    : " Checkout remains paused until the note is saved. Retry the save " +
      "or clear the note to continue.";
  var visibleMessage = message + guidance;
  var controls = getCartNoteControls(document);
  var sourceControl = controls.filter(function (control) {
    return control.id === cartNoteLifecycle.lastSourceId;
  })[0] || controls[0];
  var sourceLabel = getCartNoteLabel(sourceControl);
  var announcement = sourceLabel
    ? sourceLabel + ": " + visibleMessage
    : visibleMessage;
  controls.forEach(function (control) {
    var status = ensureCartNoteStatus(control);
    if (!status) return;
    var label = getCartNoteLabel(control);
    status.className = "cart-item-error error-text upv-cart-note-status";
    status.setAttribute("aria-live", "off");
    status.setAttribute("role", "status");
    status.textContent = label
      ? label + ": " + visibleMessage
      : visibleMessage;
    appendCartNoteErrorActions(status);
    control.setAttribute("aria-invalid", "true");
  });
  var globalStatus = ensureGlobalCartNoteStatus();
  if (!globalStatus) {
    syncCartNoteCheckoutState();
    return;
  }
  if (announce !== false) {
    globalStatus.removeAttribute("aria-live");
    globalStatus.setAttribute("role", "alert");
    globalStatus.textContent = announcement;
  } else {
    globalStatus.setAttribute("aria-live", "off");
    globalStatus.setAttribute("role", "status");
    globalStatus.textContent = "";
  }
  syncCartNoteCheckoutState();
}

function syncCartNoteControls(sourceControl) {
  if (cartNoteLifecycle.desiredValue === null) return;
  getCartNoteControls(document).forEach(function (control) {
    if (control === sourceControl) return;
    if (
      document.activeElement === control &&
      cartNoteLifecycle.composingElements.has(control)
    ) return;
    if (control.value !== cartNoteLifecycle.desiredValue) {
      control.value = cartNoteLifecycle.desiredValue;
    }
  });
}

function isCartNoteDirty() {
  return (
    cartNoteLifecycle.desiredValue !== null &&
    cartNoteLifecycle.desiredValue !== cartNoteLifecycle.confirmedValue
  );
}

function scheduleCartNoteSave(delay) {
  reconcileCartNoteComposition();
  if (cartNoteLifecycle.lastSaveUncertain) {
    if (cartNoteLifecycle.timer) clearTimeout(cartNoteLifecycle.timer);
    cartNoteLifecycle.timer = null;
    syncCartNoteCheckoutState();
    return false;
  }
  if (!isCartNoteDirty()) {
    if (cartNoteLifecycle.timer) clearTimeout(cartNoteLifecycle.timer);
    cartNoteLifecycle.timer = null;
    return false;
  }
  if (cartNoteLifecycle.timer) clearTimeout(cartNoteLifecycle.timer);
  cartNoteLifecycle.timer = setTimeout(function () {
    cartNoteLifecycle.timer = null;
    cartNoteLifecycle.compositionFlushPending = false;
    flushCartNoteSave();
  }, typeof delay === "number" ? delay : 750);
  return true;
}

function requestCartNoteRetry() {
  if (
    cartNoteLifecycle.lastSaveUncertain ||
    !isCartNoteDirty()
  ) {
    syncCartNoteCheckoutState();
    return false;
  }
  if (cartNoteLifecycle.inFlight) {
    cartNoteLifecycle.retryAfterInFlight = true;
    syncCartNoteCheckoutState();
    return true;
  }
  var scheduled = scheduleCartNoteSave(0);
  syncCartNoteCheckoutState();
  return scheduled;
}

function resumeTimedOutCartNoteRequest() {
  return typeof cartNoteLifecycle.resumeTimedOutRequest === "function"
    ? cartNoteLifecycle.resumeTimedOutRequest()
    : false;
}

function setDesiredCartNote(value, sourceControl, scheduleDelay) {
  var normalizedValue = normalizeCartNoteValue(value);
  if (sourceControl && sourceControl.id) {
    cartNoteLifecycle.lastSourceId = sourceControl.id;
  }
  if (
    sourceControl &&
    sourceControl.value !== normalizedValue &&
    !cartNoteLifecycle.composingElements.has(sourceControl)
  ) {
    sourceControl.value = normalizedValue;
  }
  var changed = cartNoteLifecycle.desiredValue !== normalizedValue;
  if (changed) {
    cartNoteLifecycle.desiredValue = normalizedValue;
    cartNoteLifecycle.revision += 1;
    cartNoteLifecycle.stateVersion += 1;
    if (!cartNoteLifecycle.lastSaveUncertain) clearCartNoteError();
  }
  syncCartNoteControls(sourceControl);
  if (
    typeof scheduleDelay === "number" &&
    cartNoteLifecycle.composingCount === 0
  ) {
    scheduleCartNoteSave(scheduleDelay);
  }
  syncCartNoteCheckoutState();
  return changed;
}

function settleCartNoteSave(
  sentValue,
  sentRevision,
  succeeded,
  cart,
  xhr,
  settleMutation,
  uncertain
) {
  cartNoteLifecycle.inFlight = false;
  cartNoteLifecycle.request = null;
  setCartNoteControlsBusy(false);
  var serverValue =
    cart && Object.prototype.hasOwnProperty.call(cart, "note")
      ? normalizeCartNoteValue(cart.note)
      : null;
  if (succeeded) {
    cartNoteLifecycle.lastSaveUncertain = false;
    if (cartNoteLifecycle.confirmedValue !== sentValue) {
      cartNoteLifecycle.stateVersion += 1;
    }
    cartNoteLifecycle.confirmedValue = sentValue;
    clearCartNoteError();
  } else {
    if (uncertain) cartNoteLifecycle.lastSaveUncertain = true;
    if (serverValue === null) {
      serverValue = cartNoteLifecycle.confirmedValue;
    }
  }
  if (!succeeded && serverValue !== null) {
    if (cartNoteLifecycle.confirmedValue !== serverValue) {
      cartNoteLifecycle.stateVersion += 1;
    }
    cartNoteLifecycle.confirmedValue = serverValue;
  }
  var newerIntent =
    cartNoteLifecycle.revision !== sentRevision ||
    cartNoteLifecycle.desiredValue !== sentValue;
  var retryRequested = cartNoteLifecycle.retryAfterInFlight;
  cartNoteLifecycle.retryAfterInFlight = false;
  if (
    !succeeded &&
    (cartNoteLifecycle.lastSaveUncertain || !newerIntent)
  ) showCartNoteError(xhr);
  settleMutation(cart, succeeded);
  if (
    !cartNoteLifecycle.lastSaveUncertain &&
    isCartNoteDirty() &&
    (newerIntent || retryRequested)
  ) {
    scheduleCartNoteSave(0);
  }
  syncCartNoteCheckoutState();
}

function reconcileLateCartNoteSave(sentValue, cart) {
  if (
    !cart ||
    !Object.prototype.hasOwnProperty.call(cart, "note") ||
    normalizeCartNoteValue(cart.note) !== sentValue
  ) return false;
  if (cartNoteLifecycle.confirmedValue !== sentValue) {
    cartNoteLifecycle.stateVersion += 1;
  }
  cartNoteLifecycle.confirmedValue = sentValue;
  cartNoteLifecycle.lastSaveUncertain = false;
  if (cartNoteLifecycle.desiredValue === sentValue) {
    clearCartNoteError();
  } else if (isCartNoteDirty()) {
    clearCartNoteError();
    scheduleCartNoteSave(0);
  }
  syncCartNoteCheckoutState();
  return true;
}

function recoverCartNoteSave(sentValue, xhr, finish, uncertain) {
  var recoveryRequest = null;
  try {
    recoveryRequest = jQuery.ajax({
      url: cartUrl,
      type: "GET",
      dataType: "json",
      timeout: cartNoteRecoveryTimeout,
      success: function (cart) {
        var matched =
          !!cart && normalizeCartNoteValue(cart.note) === sentValue;
        finish(matched, cart, xhr, matched ? false : uncertain);
      },
      error: function (recoveryXhr) {
        finish(false, null, xhr || recoveryXhr, uncertain);
      }
    });
  } catch (error) {
    finish(false, null, xhr, uncertain);
    return;
  }
  cartNoteLifecycle.request = recoveryRequest;
}

function requestCartNoteSave(sentValue, sentRevision, settleMutation) {
  var settled = false;
  var transportTimedOut = false;
  var recoveryStarted = false;
  var watchdog = null;
  var abortController = null;
  var finish = function (succeeded, cart, xhr, uncertain) {
    if (settled) return;
    settled = true;
    if (watchdog) clearTimeout(watchdog);
    watchdog = null;
    if (
      cartNoteLifecycle.resumeTimedOutRequest === resumeTimedOutRequest
    ) {
      cartNoteLifecycle.resumeTimedOutRequest = null;
    }
    settleCartNoteSave(
      sentValue,
      sentRevision,
      succeeded,
      cart,
      xhr,
      settleMutation,
      uncertain === true
    );
  };
  var recover = function (xhr, uncertain) {
    if (settled || recoveryStarted) return;
    recoveryStarted = true;
    recoverCartNoteSave(sentValue, xhr, finish, uncertain === true);
  };
  var resumeTimedOutRequest = function () {
    if (
      settled ||
      !transportTimedOut ||
      document.visibilityState === "hidden"
    ) return false;
    if (abortController && typeof abortController.abort === "function") {
      try {
        abortController.abort();
      } catch (error) {}
    }
    recover(null, true);
    return true;
  };
  cartNoteLifecycle.resumeTimedOutRequest = resumeTimedOutRequest;
  watchdog = setTimeout(function () {
    if (settled) return;
    transportTimedOut = true;
    resumeTimedOutRequest();
  }, cartNoteRequestTimeout);
  var body = null;
  if (sentValue.length < 60000) {
    try {
      body = "note=" + encodeURIComponent(sentValue);
    } catch (error) {
      finish(false, null, null, false);
      return;
    }
  }
  if (
    body !== null &&
    body.length < 60000 &&
    typeof window.fetch === "function"
  ) {
    try {
      if (typeof window.AbortController === "function") {
        abortController = new window.AbortController();
      }
      var fetchOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json"
        },
        body: body,
        credentials: "same-origin",
        keepalive: true
      };
      if (abortController) fetchOptions.signal = abortController.signal;
      var fetchRequest = window.fetch(cartUpdateUrl, fetchOptions);
      if (fetchRequest && typeof fetchRequest.then === "function") {
        cartNoteLifecycle.request = fetchRequest;
        fetchRequest
          .then(function (response) {
            if (!response || typeof response.json !== "function") {
              throw new Error("Invalid cart note response");
            }
            return response.json().then(function (cart) {
              if (settled) {
                if (transportTimedOut) {
                  reconcileLateCartNoteSave(sentValue, cart);
                }
                return;
              }
              if (response.ok === false) {
                recover(
                  { status: response.status, responseJSON: cart },
                  !(response.status >= 400 && response.status < 500)
                );
                return;
              }
              var returnedValue =
                cart && Object.prototype.hasOwnProperty.call(cart, "note")
                  ? normalizeCartNoteValue(cart.note)
                  : null;
              if (returnedValue === sentValue) {
                finish(true, cart, null, false);
              } else {
                recover(null, true);
              }
            });
          })
          .catch(function () {
            recover(null, true);
          });
        return;
      }
      finish(false, null, null, true);
      return;
    } catch (error) {
      finish(false, null, null, true);
      return;
    }
  }
  try {
    cartNoteLifecycle.request = jQuery.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: sentValue },
      dataType: "json",
      timeout: cartNoteRequestTimeout,
      success: function (cart) {
        if (settled) {
          if (transportTimedOut) {
            reconcileLateCartNoteSave(sentValue, cart);
          }
          return;
        }
        var returnedValue =
          cart && Object.prototype.hasOwnProperty.call(cart, "note")
            ? normalizeCartNoteValue(cart.note)
            : null;
        if (returnedValue === sentValue) {
          finish(true, cart, null, false);
        } else {
          recover(null, true);
        }
      },
      error: function (xhr) {
        var status = Number(xhr && xhr.status);
        recover(xhr, !(status >= 400 && status < 500));
      }
    });
  } catch (error) {
    finish(false, null, null, true);
  }
}

function flushCartNoteSave() {
  reconcileCartNoteComposition();
  if (cartNoteLifecycle.timer) clearTimeout(cartNoteLifecycle.timer);
  cartNoteLifecycle.timer = null;
  cartNoteLifecycle.compositionFlushPending = false;
  if (cartNoteLifecycle.lastSaveUncertain) {
    syncCartNoteCheckoutState();
    return false;
  }
  if (!isCartNoteDirty() || cartNoteLifecycle.composingCount > 0) {
    syncCartNoteCheckoutState();
    return false;
  }
  if (cartNoteLifecycle.queued) {
    syncCartNoteCheckoutState();
    return false;
  }
  if (cartNoteLifecycle.inFlight) {
    if (cartNoteLifecycle.revision !== cartNoteLifecycle.sentRevision) {
      cartNoteLifecycle.retryAfterInFlight = true;
    }
    syncCartNoteCheckoutState();
    return false;
  }
  cartNoteLifecycle.queued = true;
  var task = queueExternalCartMutation(
    function (settleMutation) {
      cartNoteLifecycle.queued = false;
      if (!isCartNoteDirty()) {
        settleMutation(null, true);
        syncCartNoteCheckoutState();
        return;
      }
      cartNoteLifecycle.inFlight = true;
      setCartNoteControlsBusy(true);
      syncCartNoteCheckoutState();
      var sentValue = cartNoteLifecycle.desiredValue;
      var sentRevision = cartNoteLifecycle.revision;
      cartNoteLifecycle.sentRevision = sentRevision;
      requestCartNoteSave(sentValue, sentRevision, settleMutation);
    },
    null,
    null,
    { affectsQuantity: false, affectsRender: false }
  );
  if (!task) cartNoteLifecycle.queued = false;
  syncCartNoteCheckoutState();
  return !!task;
}

function captureCartNoteRenderState(root) {
  var searchRoot = root || document;
  var activeElement = document.activeElement;
  var focusedControl =
    isCartNoteControl(activeElement) &&
    (!searchRoot.contains || searchRoot.contains(activeElement))
      ? activeElement
      : null;
  if (focusedControl) {
    setDesiredCartNote(focusedControl.value, focusedControl);
  }
  var compositionInterrupted = releaseCartNoteComposition(focusedControl);
  var drawer =
    searchRoot.closest && searchRoot.closest("[data-side-drawer]")
      ? searchRoot.closest("[data-side-drawer]")
      : searchRoot.querySelector &&
          searchRoot.querySelector("[data-side-drawer]");
  var toggle = drawer && drawer.querySelector(".cartDrawerNote");
  return {
    controlId: focusedControl ? focusedControl.id : "",
    compositionInterrupted: compositionInterrupted,
    drawerExpanded: !!(
      toggle && toggle.getAttribute("aria-expanded") === "true"
    ),
    hadFocus: !!focusedControl,
    selectionEnd:
      focusedControl && typeof focusedControl.selectionEnd === "number"
        ? focusedControl.selectionEnd
        : null,
    selectionStart:
      focusedControl && typeof focusedControl.selectionStart === "number"
        ? focusedControl.selectionStart
        : null,
    scrollTop: focusedControl ? focusedControl.scrollTop : 0
  };
}

function hydrateCartNoteControls(root, serverNote, renderState) {
  var disconnectedComposition = reconcileCartNoteComposition();
  var controls = getCartNoteControls(root || document);
  if (!controls.length) {
    syncCartNoteCheckoutState();
    return false;
  }
  var preserveLifecycleBaseline = !!(
    renderState && renderState.preserveLifecycleBaseline
  );
  var renderedServerNote =
    controls[0] && typeof controls[0].defaultValue !== "undefined"
      ? controls[0].defaultValue
      : controls[0].value;
  var serverValue =
    typeof serverNote !== "undefined"
      ? normalizeCartNoteValue(serverNote)
      : normalizeCartNoteValue(renderedServerNote);
  var stateChangedDuringRender = !!(
    renderState &&
    typeof renderState.requestStateVersion === "number" &&
    renderState.requestStateVersion !== cartNoteLifecycle.stateVersion
  );
  if (cartNoteLifecycle.desiredValue === null) {
    cartNoteLifecycle.desiredValue = serverValue;
    cartNoteLifecycle.confirmedValue = serverValue;
    cartNoteLifecycle.stateVersion += 1;
  } else if (
    !preserveLifecycleBaseline &&
    !stateChangedDuringRender &&
    !isCartNoteDirty() &&
    !cartNoteLifecycle.queued &&
    !cartNoteLifecycle.inFlight &&
    !cartNoteLifecycle.lastSaveUncertain
  ) {
    if (
      cartNoteLifecycle.desiredValue !== serverValue ||
      cartNoteLifecycle.confirmedValue !== serverValue
    ) {
      cartNoteLifecycle.stateVersion += 1;
    }
    cartNoteLifecycle.desiredValue = serverValue;
    cartNoteLifecycle.confirmedValue = serverValue;
  }
  controls.forEach(function (control) {
    ensureCartNoteStatus(control);
    if (control.value !== cartNoteLifecycle.desiredValue) {
      control.value = cartNoteLifecycle.desiredValue;
    }
  });
  syncCartNoteControls();
  if (cartNoteLifecycle.inFlight) setCartNoteControlsBusy(true);
  if (cartNoteLifecycle.lastErrorMessage) {
    showCartNoteError({
      responseJSON: { description: cartNoteLifecycle.lastErrorMessage }
    }, false);
  }
  if (renderState && renderState.drawerExpanded) {
    var searchRoot = root || document;
    var drawer =
      searchRoot.closest && searchRoot.closest("[data-side-drawer]")
        ? searchRoot.closest("[data-side-drawer]")
        : searchRoot.querySelector &&
            searchRoot.querySelector("[data-side-drawer]");
    var toggle = drawer && drawer.querySelector(".cartDrawerNote");
    var container = drawer && drawer.querySelector("#CartDrawerNoteContainer");
    if (toggle) {
      toggle.classList.add("active");
      toggle.setAttribute("aria-expanded", "true");
    }
    if (container) {
      container.style.display = "block";
      container.setAttribute("aria-hidden", "false");
    }
  }
  if (
    ((renderState && renderState.compositionInterrupted) ||
      disconnectedComposition) &&
    isCartNoteDirty()
  ) {
    scheduleCartNoteSave(750);
  }
  syncCartNoteCheckoutState();
  return true;
}

function restoreCartNoteSelectionAfterRender(root, renderState) {
  if (!renderState || !renderState.hadFocus || !renderState.controlId) {
    return false;
  }
  var searchRoot = root || document;
  var control = searchRoot.querySelector
    ? searchRoot.querySelector("#" + renderState.controlId)
    : null;
  if (!control || document.activeElement !== control) return false;
  if (
    typeof control.setSelectionRange === "function" &&
    typeof renderState.selectionStart === "number" &&
    typeof renderState.selectionEnd === "number"
  ) {
    var valueLength = control.value.length;
    control.setSelectionRange(
      Math.min(renderState.selectionStart, valueLength),
      Math.min(renderState.selectionEnd, valueLength)
    );
  }
  control.scrollTop = renderState.scrollTop || 0;
  return true;
}

function captureActiveCartNote(finalizeComposition) {
  if (!isCartNoteControl(document.activeElement)) return false;
  setDesiredCartNote(document.activeElement.value, document.activeElement);
  if (finalizeComposition) {
    if (releaseCartNoteComposition(document.activeElement)) {
      cartNoteLifecycle.compositionFlushPending = true;
      scheduleCartNoteSave(0);
      syncCartNoteCheckoutState();
      return "composition";
    }
  }
  return true;
}

function getCartNoteActionControl() {
  var controls = getCartNoteControls(document);
  return controls.filter(function (control) {
    return control.id === cartNoteLifecycle.lastSourceId;
  })[0] || controls[0] || null;
}

function retryCartNoteSave() {
  if (cartNoteLifecycle.lastSaveUncertain) return false;
  var control = getCartNoteActionControl();
  if (control) {
    releaseCartNoteComposition(control);
    setDesiredCartNote(control.value, control);
  }
  clearCartNoteError();
  announceCartNoteCheckoutStatus("Saving your note…", false);
  return flushCartNoteSave();
}

function clearAndSaveCartNote() {
  if (cartNoteLifecycle.lastSaveUncertain) return false;
  var control = getCartNoteActionControl();
  if (!control) return false;
  releaseCartNoteComposition(control);
  control.value = "";
  setDesiredCartNote("", control);
  clearCartNoteError();
  if (!isCartNoteDirty()) {
    syncCartNoteCheckoutState();
    return true;
  }
  announceCartNoteCheckoutStatus("Clearing your note…", false);
  return flushCartNoteSave();
}

cartNoteLifecycle.flush = flushCartNoteSave;
cartNoteLifecycle.hydrate = hydrateCartNoteControls;
cartNoteLifecycle.isCheckoutBlocked = isCartNoteCheckoutBlocked;
cartNoteLifecycle.isDirty = isCartNoteDirty;
cartNoteLifecycle.syncCheckout = syncCartNoteCheckoutState;

$(document).off(".upvCartNoteLifecycle");
$(document).on(
  "compositionstart.upvCartNoteLifecycle",
  cartNoteControlSelector,
  function () {
    if (
      cartNoteLifecycle.compositionOwner &&
      cartNoteLifecycle.compositionOwner !== this
    ) {
      releaseCartNoteComposition(cartNoteLifecycle.compositionOwner);
    }
    cartNoteLifecycle.compositionOwner = this;
    if (!cartNoteLifecycle.composingElements.has(this)) {
      cartNoteLifecycle.composingElements.add(this);
      cartNoteLifecycle.composingCount += 1;
    }
    if (cartNoteLifecycle.timer) clearTimeout(cartNoteLifecycle.timer);
    cartNoteLifecycle.timer = null;
    syncCartNoteCheckoutState();
  }
);
$(document).on(
  "input.upvCartNoteLifecycle",
  cartNoteControlSelector,
  function (event) {
    var composing =
      cartNoteLifecycle.composingElements.has(this) ||
      !!(event.originalEvent && event.originalEvent.isComposing);
    setDesiredCartNote(this.value, this, composing ? undefined : 750);
  }
);
$(document).on(
  "compositionend.upvCartNoteLifecycle",
  cartNoteControlSelector,
  function () {
    releaseCartNoteComposition(this);
    setDesiredCartNote(this.value, this, 0);
  }
);
$(document).on(
  "focusout.upvCartNoteLifecycle",
  cartNoteControlSelector,
  function () {
    var compositionInterrupted = releaseCartNoteComposition(this);
    setDesiredCartNote(this.value, this);
    if (compositionInterrupted) {
      cartNoteLifecycle.compositionFlushPending = true;
      scheduleCartNoteSave(0);
    } else {
      flushCartNoteSave();
    }
  }
);
$(document).on(
  "change.upvCartNoteLifecycle",
  cartNoteControlSelector,
  function () {
    setDesiredCartNote(this.value, this);
    if (cartNoteLifecycle.compositionFlushPending) {
      scheduleCartNoteSave(0);
      return;
    }
    flushCartNoteSave();
  }
);
$(document).on(
  "click.upvCartNoteLifecycle",
  "[data-upv-cart-note-retry]",
  function (event) {
    event.preventDefault();
    retryCartNoteSave();
  }
);
$(document).on(
  "click.upvCartNoteLifecycle",
  "[data-upv-cart-note-clear]",
  function (event) {
    event.preventDefault();
    clearAndSaveCartNote();
  }
);
$(document).on(
  "click.upvCartNoteLifecycle",
  "[data-upv-cart-note-reload]",
  function (event) {
    event.preventDefault();
    if (
      window.location &&
      typeof window.location.reload === "function"
    ) window.location.reload();
  }
);

function resolveCartNoteCheckoutTarget(event) {
  var eventTarget = event && event.target;
  var standard =
    eventTarget && typeof eventTarget.closest === "function"
      ? eventTarget.closest(cartNoteStandardCheckoutSelector)
      : null;
  if (standard) {
    return {
      element: standard,
      surface:
        standard.closest && standard.closest(".cart-btn-container")
          ? "drawer"
          : "page"
    };
  }
  var accelerated =
    eventTarget && typeof eventTarget.closest === "function"
      ? eventTarget.closest(cartNoteAcceleratedCheckoutSelector)
      : null;
  var path =
    !accelerated && event && typeof event.composedPath === "function"
      ? event.composedPath()
      : [];
  for (var index = 0; !accelerated && index < path.length; index += 1) {
    var pathElement = path[index];
    if (
      pathElement &&
      typeof pathElement.matches === "function" &&
      pathElement.matches(cartNoteAcceleratedCheckoutSelector)
    ) accelerated = pathElement;
    else if (
      pathElement &&
      typeof pathElement.closest === "function"
    ) accelerated = pathElement.closest(cartNoteAcceleratedCheckoutSelector);
  }
  return accelerated
    ? { element: accelerated, surface: "accelerated" }
    : null;
}

function stopCartNoteCheckoutEvent(event) {
  if (event && typeof event.preventDefault === "function") {
    event.preventDefault();
  }
  if (event && typeof event.stopImmediatePropagation === "function") {
    event.stopImmediatePropagation();
  } else if (event && typeof event.stopPropagation === "function") {
    event.stopPropagation();
  }
}

function beginCartNoteCheckoutIntent(event, checkoutTarget) {
  var interruptedComposition = captureActiveCartNote(true) === "composition";
  var gestureTarget = cartNoteLifecycle.blockedGestureTarget;
  var blocked =
    isCartNoteCheckoutBlocked() ||
    !!(gestureTarget && checkoutTarget.element === gestureTarget);
  syncCartNoteCheckoutState();
  if (!blocked) return false;

  stopCartNoteCheckoutEvent(event);
  if (cartNoteLifecycle.blockedGestureClearTimer) {
    clearTimeout(cartNoteLifecycle.blockedGestureClearTimer);
    cartNoteLifecycle.blockedGestureClearTimer = null;
  }
  cartNoteLifecycle.blockedGestureTarget = null;
  var firstIntent =
    !cartNoteLifecycle.checkoutIntent ||
    (cartNoteLifecycle.checkoutIntent.target &&
      cartNoteLifecycle.checkoutIntent.target.isConnected === false);
  if (firstIntent) {
    cartNoteLifecycle.checkoutIntent = {
      surface: checkoutTarget.surface,
      target: checkoutTarget.element
    };
  }
  if (cartNoteLifecycle.lastSaveUncertain) {
    showCartNoteError(
      { responseJSON: { description: cartNoteLifecycle.lastErrorMessage } },
      firstIntent
    );
    syncCartNoteCheckoutState();
    return true;
  }
  if (cartNoteLifecycle.lastErrorMessage) {
    retryCartNoteSave();
    return true;
  }
  if (firstIntent) {
    announceCartNoteCheckoutStatus(
      "Saving your note. Checkout will be available when it is saved.",
      false
    );
  }
  if (interruptedComposition || cartNoteLifecycle.compositionFlushPending) {
    scheduleCartNoteSave(0);
  } else {
    flushCartNoteSave();
  }
  return true;
}

function handleCartNoteCheckoutActivation(event) {
  var checkoutTarget = resolveCartNoteCheckoutTarget(event);
  if (!checkoutTarget) return false;
  if (beginCartNoteCheckoutIntent(event, checkoutTarget)) return true;
  return blockPendingCartMutationCheckout(event);
}

function blockPendingCartMutationCheckout(event) {
  if (typeof isCartMutationCheckoutBlocked !== "function" ||
      !isCartMutationCheckoutBlocked()) return false;
  stopCartNoteCheckoutEvent(event);
  syncCartMutationCheckoutState();
  announceCartNoteCheckoutStatus(window.upvCartUpdatingLabel || "", false);
  return true;
}

function handleCartNoteCheckoutPointerStart(event) {
  var checkoutTarget = resolveCartNoteCheckoutTarget(event);
  if (!checkoutTarget) return;
  captureActiveCartNote(false);
  syncCartNoteCheckoutState();
  if (cartNoteLifecycle.blockedGestureClearTimer) {
    clearTimeout(cartNoteLifecycle.blockedGestureClearTimer);
    cartNoteLifecycle.blockedGestureClearTimer = null;
  }
  cartNoteLifecycle.blockedGestureTarget = isCartNoteCheckoutBlocked()
    ? checkoutTarget.element
    : null;
}

function clearCartNoteBlockedGestureSoon() {
  var blockedTarget = cartNoteLifecycle.blockedGestureTarget;
  if (!blockedTarget) return;
  if (cartNoteLifecycle.blockedGestureClearTimer) {
    clearTimeout(cartNoteLifecycle.blockedGestureClearTimer);
  }
  cartNoteLifecycle.blockedGestureClearTimer = setTimeout(function () {
    cartNoteLifecycle.blockedGestureClearTimer = null;
    if (cartNoteLifecycle.blockedGestureTarget === blockedTarget) {
      cartNoteLifecycle.blockedGestureTarget = null;
    }
  }, 0);
}

function cancelCartNoteBlockedGesture() {
  if (cartNoteLifecycle.blockedGestureClearTimer) {
    clearTimeout(cartNoteLifecycle.blockedGestureClearTimer);
    cartNoteLifecycle.blockedGestureClearTimer = null;
  }
  cartNoteLifecycle.blockedGestureTarget = null;
}

function isCartNoteCartForm(form) {
  return !!(
    form &&
    form.matches &&
    form.matches('form[action$="/cart"], form[action$="/cart/"]')
  );
}

if (cartNoteLifecycle.nativeHandlers) {
  [
    "auxclick",
    "click",
    "contextmenu",
    "dblclick",
    "keydown",
    "mousedown",
    "mouseup",
    "pointercancel",
    "pointerdown",
    "pointerup",
    "submit"
  ].forEach(function (eventName) {
    if (cartNoteLifecycle.nativeHandlers[eventName]) {
      document.removeEventListener(
        eventName,
        cartNoteLifecycle.nativeHandlers[eventName],
        true
      );
    }
  });
  document.removeEventListener(
    "visibilitychange",
    cartNoteLifecycle.nativeHandlers.visibility
  );
  window.removeEventListener(
    "pagehide",
    cartNoteLifecycle.nativeHandlers.pagehide
  );
  window.removeEventListener(
    "pageshow",
    cartNoteLifecycle.nativeHandlers.pageshow
  );
  window.removeEventListener("online", cartNoteLifecycle.nativeHandlers.online);
}
cartNoteLifecycle.nativeHandlers = {
  auxclick: handleCartNoteCheckoutActivation,
  click: handleCartNoteCheckoutActivation,
  contextmenu: handleCartNoteCheckoutActivation,
  dblclick: handleCartNoteCheckoutActivation,
  keydown: function (event) {
    if (!event || (event.key !== "Enter" && event.key !== " ")) return;
    handleCartNoteCheckoutActivation(event);
  },
  mousedown: handleCartNoteCheckoutPointerStart,
  mouseup: clearCartNoteBlockedGestureSoon,
  online: function () {
    resumeTimedOutCartNoteRequest();
    requestCartNoteRetry();
  },
  pagehide: function () {
    cartNoteLifecycle.checkoutIntent = null;
    cancelCartNoteBlockedGesture();
    captureActiveCartNote(true);
    flushCartNoteSave();
  },
  pageshow: function (event) {
    hydrateCartNoteControls(document, undefined, {
      preserveLifecycleBaseline: true
    });
    resumeTimedOutCartNoteRequest();
    if (event && event.persisted && isCartNoteDirty()) {
      requestCartNoteRetry();
    }
    syncCartNoteCheckoutState();
  },
  pointerdown: handleCartNoteCheckoutPointerStart,
  pointercancel: cancelCartNoteBlockedGesture,
  pointerup: clearCartNoteBlockedGestureSoon,
  submit: function (event) {
    var form = event.target;
    if (!isCartNoteCartForm(form)) return;
    var submitter = event.submitter;
    var checkoutTarget = submitter
      ? resolveCartNoteCheckoutTarget({ target: submitter })
      : { element: form, surface: "page" };
    if (!checkoutTarget) {
      captureActiveCartNote(true);
      flushCartNoteSave();
      return;
    }
    if (!beginCartNoteCheckoutIntent(event, checkoutTarget)) {
      blockPendingCartMutationCheckout(event);
    }
  },
  visibility: function () {
    if (document.visibilityState !== "hidden") {
      resumeTimedOutCartNoteRequest();
      requestCartNoteRetry();
      return;
    }
    captureActiveCartNote(true);
    flushCartNoteSave();
  }
};
[
  "auxclick",
  "click",
  "contextmenu",
  "dblclick",
  "keydown",
  "mousedown",
  "mouseup",
  "pointercancel",
  "pointerdown",
  "pointerup",
  "submit"
].forEach(function (eventName) {
  document.addEventListener(
    eventName,
    cartNoteLifecycle.nativeHandlers[eventName],
    true
  );
});
document.addEventListener(
  "visibilitychange",
  cartNoteLifecycle.nativeHandlers.visibility
);
window.addEventListener("pagehide", cartNoteLifecycle.nativeHandlers.pagehide);
window.addEventListener("pageshow", cartNoteLifecycle.nativeHandlers.pageshow);
window.addEventListener("online", cartNoteLifecycle.nativeHandlers.online);
hydrateCartNoteControls(document);

if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations

  (function () {
    var shippingEstimateLifecycle =
      window.UpvanityShippingEstimateLifecycle &&
      typeof window.UpvanityShippingEstimateLifecycle === "object"
        ? window.UpvanityShippingEstimateLifecycle
        : { button: null, country: null };
    window.UpvanityShippingEstimateLifecycle = shippingEstimateLifecycle;

    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        if (shippingEstimateLifecycle.country !== country) {
          new Shopify.CountryProvinceSelector(
            "shippingCountry",
            "shippingProvince",
            {
              hideElement: "shippingProvinceContainer",
            }
          );
          shippingEstimateLifecycle.country = country;
        }

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (!button || shippingEstimateLifecycle.button === button) return;
      button.addEventListener("click", (e) => {
        e.preventDefault();
        $("#ShippingWrapperResponse")
          .html("")
          .removeClass("success")
          .removeClass("error")
          .hide();
        var shippingAddress = {};
        shippingAddress.zip = jQuery("#shippingZip").val() || "";
        shippingAddress.country = jQuery("#shippingCountry").val() || "";
        shippingAddress.province = jQuery("#shippingProvince").val() || "";
        _getCartShippingRates(shippingAddress);
      });
      shippingEstimateLifecycle.button = button;
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result)
          }
        },
      });
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();

  // Update quantity based on input on change

  changeCartItem = function (line, quantity, itemKey, focusIntent) {
    var mutationState = queueCartQuantityChange(line, quantity, itemKey, function (
      cart,
      succeeded,
      batchResult
    ) {
      if (cart) {
        return cartPageUpdate(cart, batchResult, focusIntent);
      } else {
        if (!succeeded) $("#cartItemError-" + line).text(errorLabel);
        recoverUnverifiedCartMutation(null);
        restoreCartInteractionState();
      }
      return null;
    });
    assignCartMutationFocusSequence(focusIntent, mutationState);
    return mutationState;
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(
        line,
        qty,
        parent.attr("data-cart-item-key"),
        captureCartMutationFocus(this, "page")
      );
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity

    if (line) {
      changeCartItem(
        line,
        qty,
        parent.attr("data-cart-item-key"),
        captureCartMutationFocus(this, "page")
      );
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(
        line,
        0,
        parent.attr("data-cart-item-key"),
        captureCartMutationFocus(this, "page")
      );
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, itemKey, callback) {
    if (typeof itemKey === "function") {
      callback = itemKey;
      itemKey = null;
    }
    return queueCartQuantityChange(line, quantity, itemKey, callback);
  };

  updateQuantity = function (line, qty, itemKey, callback) {
    if (typeof itemKey === "function") {
      callback = itemKey;
      itemKey = null;
    }
    return changeItem(line, qty, itemKey, function (cart, succeeded, batchResult) {
      if (typeof callback === "function") {
        return callback(cart, succeeded, batchResult);
      }
      return null;
    });
  };

  $(document)
    .off("change.upvGiftCardRecipient", "#Recipient-Checkbox")
    .on(
      "change.upvGiftCardRecipient",
      "#Recipient-Checkbox",
      function () {
        if (this.checked) return;
        var recipientForm = getCartAddFormElement(this);
        var recipientBox = $(this).closest("[data-gift-card-box]");
        var recipientScope = recipientBox.length
          ? recipientBox
          : recipientForm
            ? $(recipientForm)
            : recipientBox;
        recipientScope
          .find('input[data-attr="email"], input[data-attr="name"]')
          .val("");
      }
    );

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body")
      .off("click.upvCartAdd", ".Sd_addProduct")
      .on("click.upvCartAdd", ".Sd_addProduct", function (evt) {
        if (
          (typeof evt.isDefaultPrevented === "function" &&
            evt.isDefaultPrevented()) ||
          evt.defaultPrevented ||
          this.disabled
        ) return;
        var formElement = getCartAddFormElement(this);
        if (!formElement) return;
        var activeAddState = getActiveCartAddState(formElement);
        if (activeAddState) {
          evt.preventDefault();
          applyCartAddPendingState(activeAddState);
          return;
        }
        evt.preventDefault();
        var sourceButton = this;
        var submit = $(sourceButton);
        var form = $(formElement);
        var quickAddPopupAtClick = form.closest(".quick-add-popup");
        var quickAddPopupElementAtClick = quickAddPopupAtClick.length
          ? quickAddPopupAtClick[0]
          : null;
        var quickAddBodyAtClick = form.closest("[quick-add-body]");
        var quickAddBodyElementAtClick = quickAddBodyAtClick.length
          ? quickAddBodyAtClick[0]
          : null;
        var quickAddTriggerAtClick =
          quickAddPopupElementAtClick &&
          quickAddPopupElementAtClick.upvQuickAddTrigger &&
          quickAddPopupElementAtClick.upvQuickAddTrigger.isConnected !== false
            ? quickAddPopupElementAtClick.upvQuickAddTrigger
            : null;
        var quickAddGenerationAtClick =
          captureQuickAddPopupGeneration(
            quickAddPopupElementAtClick,
            quickAddBodyElementAtClick,
            quickAddTriggerAtClick,
            formElement
          );
        var quickAddReturnTrigger = quickAddGenerationAtClick
          ? quickAddTriggerAtClick
          : null;
        var sharedDrawerAtClick = form.closest(".yv_side_drawer_wrapper");
        var sharedDrawerElementAtClick = sharedDrawerAtClick.length
          ? sharedDrawerAtClick[0]
          : null;
        var nativeQuickViewReturnTrigger =
          sharedDrawerElementAtClick &&
          sharedDrawerElementAtClick.getAttribute("id") ===
            "yv_quickView_product" &&
          sharedDrawerElementAtClick.classList.contains(
            "yv_quickView_product"
          ) &&
          sharedDrawerElementAtClick.upvQuickViewTrigger &&
          sharedDrawerElementAtClick.upvQuickViewTrigger.isConnected !== false
            ? sharedDrawerElementAtClick.upvQuickViewTrigger
            : null;
        var stableAddReturnTrigger =
          quickAddReturnTrigger || nativeQuickViewReturnTrigger;
        var addReturnFocusElement = stableAddReturnTrigger
          ? $(stableAddReturnTrigger)
          : submit;
        var formInSharedDrawer = sharedDrawerAtClick.length > 0;
        var errorElement = getCartAddErrorElement(
          formElement,
          sourceButton
        );
        var variantRootAtClick = getCartAddVariantRoot(formElement);
        if (isCartAddVariantBoundaryBlocked(variantRootAtClick)) {
          showAddToCartError(
            {
              responseJSON: {
                description:
                  (typeof unavailableText === "string" && unavailableText) ||
                  ((typeof errorLabel === "string" && errorLabel) || "")
              }
            },
            errorElement,
            formElement,
            sourceButton
          );
          return;
        }
        var requiresVariantSynchronization = Boolean(
          variantRootAtClick &&
          typeof variantRootAtClick.querySelector === "function" &&
          variantRootAtClick.querySelector(".product-loop-variants")
        );
        var synchronizedVariantAtAdd = null;
        var variantSynchronizationFailed = false;
        if (typeof synchronizeProductVariantInput === "function") {
          try {
            synchronizedVariantAtAdd =
              synchronizeProductVariantInput(formElement, {
                verifyOnly: true
              });
          } catch (error) {
            variantSynchronizationFailed = true;
          }
        } else if (variantRootAtClick) {
          variantSynchronizationFailed = true;
        }
        var associatedFormControls = formElement.elements
          ? Array.from(formElement.elements)
          : typeof formElement.querySelectorAll === "function"
            ? Array.from(formElement.querySelectorAll('[name="id"]'))
            : [];
        var enabledVariantInputs = associatedFormControls.filter(
          function (input) {
            var inputName = input.name ||
              (typeof input.getAttribute === "function" &&
                input.getAttribute("name"));
            var inputType = String(
              input.type ||
              (typeof input.getAttribute === "function" &&
                input.getAttribute("type")) ||
              ""
            ).toLowerCase();
            var inputIsDisabled = Boolean(input.disabled);
            if (!inputIsDisabled && typeof input.matches === "function") {
              try {
                inputIsDisabled = input.matches(":disabled");
              } catch (error) {}
            }
            if (
              inputName !== "id" ||
              inputIsDisabled ||
              ["button", "file", "image", "reset", "submit"].indexOf(inputType) > -1
            ) {
              return false;
            }
            if (
              (inputType === "checkbox" || inputType === "radio") &&
              !input.checked
            ) {
              return false;
            }
            return true;
          }
        );
        if (
          enabledVariantInputs.length !== 1 ||
          !String(enabledVariantInputs[0].value || "").trim()
        ) {
          showAddToCartError(
            {
              responseJSON: {
                description:
                  (typeof unavailableText === "string" && unavailableText) ||
                  ((typeof errorLabel === "string" && errorLabel) || "")
              }
            },
            errorElement,
            formElement,
            sourceButton
          );
          return;
        }
        if (variantRootAtClick) {
          var variantSelectionIsAuthoritative = Boolean(
            !variantSynchronizationFailed &&
            synchronizedVariantAtAdd &&
            synchronizedVariantAtAdd.authoritative === true &&
            synchronizedVariantAtAdd.resolved !== false &&
            synchronizedVariantAtAdd.available !== false &&
            synchronizedVariantAtAdd.pendingSellingPlan !== true &&
            synchronizedVariantAtAdd.sellingPlanValid !== false &&
            synchronizedVariantAtAdd.input &&
            enabledVariantInputs.length === 1 &&
            enabledVariantInputs[0] === synchronizedVariantAtAdd.input &&
            String(enabledVariantInputs[0].value) ===
              String(synchronizedVariantAtAdd.id) &&
            (
              !requiresVariantSynchronization ||
              (
                synchronizedVariantAtAdd.applicable === true &&
                synchronizedVariantAtAdd.resolved === true &&
                synchronizedVariantAtAdd.available === true
              )
            )
          );
          if (!variantSelectionIsAuthoritative) {
            var variantBlockMessage =
              synchronizedVariantAtAdd &&
              synchronizedVariantAtAdd.resolved === true &&
              synchronizedVariantAtAdd.available === false
                ? (typeof soldOutText === "string" && soldOutText) ||
                  ((typeof unavailableText === "string" && unavailableText) ||
                    ((typeof errorLabel === "string" && errorLabel) || ""))
                : (typeof unavailableText === "string" && unavailableText) ||
                  ((typeof errorLabel === "string" && errorLabel) || "");
            showAddToCartError(
              { responseJSON: { description: variantBlockMessage } },
              errorElement,
              formElement,
              sourceButton
            );
            return;
          }
        }
        var formData;
        try {
          formData = form.serialize();
        } catch (error) {
          showAddToCartError(
            null,
            errorElement,
            formElement,
            sourceButton
          );
          return;
        }
        var serializedVariantIds = String(formData).split("&").filter(
          function (pair) {
            var separatorIndex = pair.indexOf("=");
            var encodedName = separatorIndex == -1 ? pair :
              pair.slice(0, separatorIndex);
            try {
              return decodeURIComponent(encodedName.replace(/\+/g, " ")) == "id";
            } catch (error) {
              return false;
            }
          }
        );
        var expectedSerializedVariantId = variantRootAtClick
          ? synchronizedVariantAtAdd.id
          : enabledVariantInputs[0].value;
        if (
          serializedVariantIds.length !== 1 ||
          serializedVariantIds[0].slice(
            serializedVariantIds[0].indexOf("=") + 1
          ) !== encodeURIComponent(String(expectedSerializedVariantId))
        ) {
          showAddToCartError(
            {
              responseJSON: {
                description:
                  (typeof unavailableText === "string" && unavailableText) ||
                  ((typeof errorLabel === "string" && errorLabel) || "")
              }
            },
            errorElement,
            formElement,
            sourceButton
          );
          return;
        }
        clearCartAddError(errorElement);
        var addLifecycleState = acquireCartAddMutation(
          formElement,
          sourceButton
        );
        if (!addLifecycleState) return;

        var addOwnsFocusAfterSuccess = false;
        var addSourceWillBeRemoved = false;
        var addSucceeded = false;
        var addDrawerReadyForRender = false;
        var cartDrawerOwnership = null;
        var accessibleCartReturnFocusOwnership = null;
        var handedOffToMutationQueue = false;
        var queuedAddMutation = null;
        var staleQuickAddCompletion = false;
        try {
          if (!formInSharedDrawer) {
            focusElement = addReturnFocusElement;
          }
          cartDrawerOwnership = prepareSharedDrawerForCart({
            disposeProductLifecycle: !formInSharedDrawer
          });
          queuedAddMutation = queueExternalCartMutation(
            function (settleMutation) {
              var addMutationSettled = false;
              var settleAddMutation = function (cart, succeeded) {
                if (addMutationSettled) return;
                addMutationSettled = true;
                releaseCartAddMutation(addLifecycleState);
                settleMutation(cart, succeeded);
              };
              var addTransportSettled = false;
              var finishAddTransport = function (
                succeeded,
                XMLHttpRequest,
                textStatus
              ) {
                if (addTransportSettled) return;
                addTransportSettled = true;
                addSucceeded = succeeded;
                var quickAddCompletionIsCurrent = Boolean(
                  !quickAddPopupElementAtClick ||
                  (
                    quickAddGenerationAtClick &&
                    isQuickAddPopupSnapshotCurrent(
                      quickAddGenerationAtClick
                    )
                  )
                );
                staleQuickAddCompletion = Boolean(
                  quickAddPopupElementAtClick &&
                  !quickAddCompletionIsCurrent
                );
                if (succeeded) {
                  try {
                    continueExternalCartMutation(
                      true,
                      function () {
                        if (staleQuickAddCompletion) {
                          if (focusElement === addReturnFocusElement) {
                            focusElement = "";
                          }
                          return;
                        }
                        var connectedStableAddReturnTrigger =
                          stableAddReturnTrigger &&
                          stableAddReturnTrigger.isConnected !== false
                            ? stableAddReturnTrigger
                            : null;
                        if (
                          stableAddReturnTrigger &&
                          !connectedStableAddReturnTrigger &&
                          focusElement === addReturnFocusElement
                        ) {
                          focusElement = "";
                        }
                        var removalRoot =
                          quickAddPopupElementAtClick ||
                          quickAddBodyElementAtClick;
                        addSourceWillBeRemoved = cartAddNodeWillBeRemoved(
                          sourceButton,
                          cartDrawerOwnership,
                          removalRoot
                        );
                        addOwnsFocusAfterSuccess =
                          document.activeElement === sourceButton ||
                          cartAddActiveElementWillBeRemoved(
                            cartDrawerOwnership,
                            removalRoot
                          );
                        if (
                          addSourceWillBeRemoved &&
                          focusElement === submit
                        ) focusElement = "";
                        if (quickAddPopupElementAtClick) {
                          retireQuickAddPopupGeneration(
                            quickAddGenerationAtClick
                          );
                          quickAddPopupElementAtClick.classList.remove("show");
                          if (
                            quickAddBodyElementAtClick &&
                            typeof disposeProductVariantLifecycle === "function"
                          ) {
                            disposeProductVariantLifecycle(
                              quickAddBodyElementAtClick
                            );
                          }
                          if (quickAddBodyElementAtClick) {
                            quickAddBodyElementAtClick.innerHTML = "";
                          }
                          document.body.classList.remove(
                            "quick-add-popup-open"
                          );
                        }
                        var canShowCartDrawer = setCartDrawerState(
                          cartDrawerOwnership,
                          true
                        );
                        addDrawerReadyForRender = canShowCartDrawer;
                        if (canShowCartDrawer) {
                          $("body").removeClass("quickview-open");
                          $("body").addClass("side_Drawer_open");
                          if (
                            connectedStableAddReturnTrigger ||
                            !addSourceWillBeRemoved
                          ) {
                            accessibleCartReturnFocusOwnership =
                              captureAccessibleCartReturnFocus(
                                connectedStableAddReturnTrigger || sourceButton
                              );
                          }
                          if (addOwnsFocusAfterSuccess) {
                            focusCartDrawerRoot(cartDrawerOwnership);
                          }
                        } else if (
                          focusElement === addReturnFocusElement
                        ) {
                          focusElement = "";
                        }
                        var addAlert = document.getElementById(
                          "addToCartAlert"
                        );
                        if (addAlert) addAlert.play();
                        if (hapticFeedbackStatus) {
                          var canVibrate = window.navigator.vibrate;
                          if (canVibrate) window.navigator.vibrate(500);
                        }
                      },
                      settleAddMutation,
                      {
                        deferSnapshotToDrawerRender: true,
                        shouldDeferSnapshot: function () {
                          return Boolean(
                            addDrawerReadyForRender &&
                            !staleQuickAddCompletion &&
                            isCartDrawerOwnershipCurrent(cartDrawerOwnership)
                          );
                        }
                      }
                    );
                  } catch (error) {
                    settleAddMutation(null, false);
                  }
                  return;
                }
                if (focusElement === addReturnFocusElement) {
                  focusElement = "";
                }
                var addOutcomeUncertain = isUncertainCartAddFailure(
                  XMLHttpRequest,
                  textStatus
                );
                try {
                  continueExternalCartMutation(
                    false,
                    function () {
                      if (staleQuickAddCompletion) return;
                      var errorHandled = false;
                      if (typeof errorCallback === "function") {
                        try {
                          errorCallback(XMLHttpRequest, textStatus);
                          errorHandled = true;
                        } catch (error) {}
                      }
                      if (addOutcomeUncertain) {
                        showUncertainCartAddError(
                          errorElement,
                          formElement,
                          sourceButton
                        );
                      } else if (!errorHandled) {
                        showAddToCartError(
                          XMLHttpRequest,
                          errorElement,
                          formElement,
                          sourceButton
                        );
                      }
                    },
                    settleAddMutation
                  );
                } catch (error) {
                  if (addOutcomeUncertain) {
                    showUncertainCartAddError(
                      errorElement,
                      formElement,
                      sourceButton
                    );
                  } else {
                    showAddToCartError(
                      null,
                      errorElement,
                      formElement,
                      sourceButton
                    );
                  }
                  settleAddMutation(null, false);
                }
              };
              var params = {
                type: "POST",
                url: cartAddUrl,
                data: formData,
                dataType: "json",
                timeout: 12000,
                success: function () {
                  finishAddTransport(true, null, "success");
                },
                error: function (XMLHttpRequest, textStatus) {
                  finishAddTransport(
                    false,
                    XMLHttpRequest,
                    textStatus
                  );
                }
              };
              try {
                jQuery.ajax(params);
              } catch (error) {
                finishAddTransport(false, null, "error");
              }
            },
            function (cart, succeeded, batchResult) {
              var cartOwnershipCurrent =
                isCartDrawerOwnershipCurrent(cartDrawerOwnership);
              if (addSucceeded && !cartOwnershipCurrent) {
                releaseAccessibleCartReturnFocus(
                  accessibleCartReturnFocusOwnership
                );
                accessibleCartReturnFocusOwnership = null;
              }
              if (
                addSucceeded &&
                !staleQuickAddCompletion &&
                !cartOwnershipCurrent &&
                focusElement === addReturnFocusElement
              ) {
                focusElement = "";
              }
              if (cart) {
                if (
                  addSucceeded &&
                  !staleQuickAddCompletion &&
                  cartOwnershipCurrent
                ) {
                  return buildCart(
                    cart,
                    true,
                    null,
                    cartDrawerOwnership,
                    batchResult
                  );
                }
                updateCartIndicators(cart);
                restoreCartInteractionState();
              } else if (
                succeeded &&
                addSucceeded &&
                !staleQuickAddCompletion &&
                cartOwnershipCurrent
              ) {
                return buildCartFromServerSnapshot(
                  true,
                  null,
                  cartDrawerOwnership,
                  batchResult,
                  null,
                  addOwnsFocusAfterSuccess
                );
              } else {
                restoreCartInteractionState();
              }
              return null;
            },
            function () {
              releaseCartAddMutation(addLifecycleState);
            }
          );
          handedOffToMutationQueue = !!queuedAddMutation;
        } catch (error) {
          if (focusElement === addReturnFocusElement) focusElement = "";
          showAddToCartError(
            null,
            errorElement,
            formElement,
            sourceButton
          );
        } finally {
          if (!handedOffToMutationQueue) {
            releaseCartAddMutation(addLifecycleState);
          }
        }
      });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        itemKey = $el.data("id") || parent.attr("data-cart-item-key"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        var focusIntent = captureCartMutationFocus(this, "drawer");
        var cartDrawerOwnership = prepareSharedDrawerForCart();
        var mutationState = updateQuantity(line, qty, itemKey, function (
          cart,
          succeeded,
          batchResult
        ) {
          if (cart) {
            if (isCartDrawerOwnershipCurrent(cartDrawerOwnership)) {
              return buildCart(
                cart,
                false,
                null,
                cartDrawerOwnership,
                batchResult,
                focusIntent
              );
            } else {
              updateCartIndicators(cart);
              restoreCartInteractionState();
            }
          } else {
            if (!succeeded) {
              $("#cartDrawerItemError-" + line).text(errorLabel);
            }
            recoverUnverifiedCartMutation(cartDrawerOwnership);
            restoreCartInteractionState();
          }
          return null;
        });
        assignCartMutationFocusSequence(focusIntent, mutationState);
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        itemKey = $el.data("id") || parent.attr("data-cart-item-key"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        var focusIntent = captureCartMutationFocus(this, "drawer");
        var cartDrawerOwnership = prepareSharedDrawerForCart();
        var mutationState = updateQuantity(line, qty, itemKey, function (
          cart,
          succeeded,
          batchResult
        ) {
          if (cart) {
            if (isCartDrawerOwnershipCurrent(cartDrawerOwnership)) {
              return buildCart(
                cart,
                false,
                null,
                cartDrawerOwnership,
                batchResult,
                focusIntent
              );
            } else {
              updateCartIndicators(cart);
              restoreCartInteractionState();
            }
          } else {
            if (!succeeded) {
              $("#cartDrawerItemError-" + line).text(errorLabel);
            }
            recoverUnverifiedCartMutation(cartDrawerOwnership);
            restoreCartInteractionState();
          }
          return null;
        });
        assignCartMutationFocusSequence(focusIntent, mutationState);
      }
    });

    function openCartDrawer(element) {
      var cartDrawerOwnership = prepareSharedDrawerForCart();
      if (!setCartDrawerState(cartDrawerOwnership, true)) return;
      $("body").addClass("side_Drawer_open");
      var cartReturnFocusTarget =
        element && element[0] ? element[0] : element;
      var accessibleCartReturnFocusOwnership =
        captureAccessibleCartReturnFocus(cartReturnFocusTarget);
      if (element) focusElement = element;
      var renderCartAfterPendingMutations = function (
        cart,
        succeeded,
        batchResult
      ) {
        var cartOwnershipCurrent =
          isCartDrawerOwnershipCurrent(cartDrawerOwnership);
        if (!cartOwnershipCurrent) {
          releaseAccessibleCartReturnFocus(
            accessibleCartReturnFocusOwnership
          );
          accessibleCartReturnFocusOwnership = null;
        }
        if (cart) {
          if (cartOwnershipCurrent) {
            return buildCart(
              cart,
              true,
              element,
              cartDrawerOwnership,
              batchResult
            );
          }
          updateCartIndicators(cart);
          restoreCartInteractionState();
        } else if (succeeded && cartOwnershipCurrent) {
          return buildCartFromServerSnapshot(
            true,
            element,
            cartDrawerOwnership,
            batchResult
          );
        } else if (cartOwnershipCurrent) {
          showCartDrawerFallback(cartDrawerOwnership);
        } else {
          restoreCartInteractionState();
        }
        return null;
      };
      if (
        deferCartReadUntilMutationsSettle(renderCartAfterPendingMutations)
      ) return;
      buildCartFromServerSnapshot(
        true,
        element,
        cartDrawerOwnership,
        {
          allSucceeded: true,
          failures: []
        }
      );
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line")),
        itemKey = $el.data("id") || parent.attr("data-cart-item-key");
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        var focusIntent = captureCartMutationFocus(this, "drawer");
        var cartDrawerOwnership = prepareSharedDrawerForCart();
        var mutationState = updateQuantity(line, 0, itemKey, function (
          cart,
          succeeded,
          batchResult
        ) {
          if (cart) {
            if (isCartDrawerOwnershipCurrent(cartDrawerOwnership)) {
              return buildCart(
                cart,
                false,
                null,
                cartDrawerOwnership,
                batchResult,
                focusIntent
              );
            } else {
              updateCartIndicators(cart);
              restoreCartInteractionState();
            }
          } else {
            if (!succeeded) {
              $("#cartDrawerItemError-" + line).text(errorLabel);
            }
            recoverUnverifiedCartMutation(cartDrawerOwnership);
            restoreCartInteractionState();
          }
          return null;
        });
        assignCartMutationFocusSequence(focusIntent, mutationState);
      }
    });

    $(document).on("click", ".cartDrawerNote", function (evt) {
      evt.preventDefault();
      var trigger = $(this),
        noteContainer = trigger.siblings(".cartNoteContainer"),
        isExpanded = trigger.attr("aria-expanded") !== "true";
      trigger
        .toggleClass("active", isExpanded)
        .attr("aria-expanded", isExpanded ? "true" : "false");
      noteContainer
        .attr("aria-hidden", isExpanded ? "false" : "true")
        .stop(true, true);
      if (isExpanded) {
        noteContainer.slideDown();
      } else {
        noteContainer.slideUp();
      }
    });
  }

}

var giftWrapMutationLifecycle =
  window.UpvanityGiftWrapMutationLifecycle &&
  typeof window.UpvanityGiftWrapMutationLifecycle === "object"
    ? window.UpvanityGiftWrapMutationLifecycle
    : { pending: false };
window.UpvanityGiftWrapMutationLifecycle = giftWrapMutationLifecycle;

function applyGiftWrapPendingState(control, pending) {
  if (!control || typeof control.data !== "function") return;
  control.data("upvGiftWrapPending", pending).prop("disabled", pending);
  if (pending) {
    control.attr("aria-disabled", "true");
  } else {
    control.removeAttr("aria-disabled");
  }
}

function setGiftWrapMutationPending(pending, initiatingControl) {
  giftWrapMutationLifecycle.pending = pending;
  applyGiftWrapPendingState(initiatingControl, pending);
  applyGiftWrapPendingState($("#GiftWrapProduct"), pending);
}

function syncGiftWrapMutationPending() {
  applyGiftWrapPendingState(
    $("#GiftWrapProduct"),
    giftWrapMutationLifecycle.pending
  );
}

$("body").on("click", "#GiftWrapProduct", function (evt) {
  evt.preventDefault();
  var giftWrapControl = $(this);
  if (giftWrapMutationLifecycle.pending) {
    applyGiftWrapPendingState(giftWrapControl, true);
    return;
  }
  var giftWrapDrawer =
    this.closest && this.closest("[data-side-drawer]");
  var giftWrapSurface = giftWrapDrawer ? "drawer" : "page";
  var giftWrapFocusIntent = captureCartMutationFocus(
    this,
    giftWrapSurface
  );
  setGiftWrapMutationPending(true, giftWrapControl);
  var giftWrapReleased = false;
  var cartDrawerOwnership =
    giftWrapSurface === "drawer" ? prepareSharedDrawerForCart() : null;
  var releaseGiftWrapPending = function () {
    if (giftWrapReleased) return;
    giftWrapReleased = true;
    setGiftWrapMutationPending(false, giftWrapControl);
    restoreGiftWrapMutationCompletionFocus(
      giftWrapFocusIntent,
      cartDrawerOwnership,
      giftWrapWriteSucceeded,
      giftWrapSurface
    );
  };
  var productId = parseInt(giftWrapControl.attr("data-product"));
  var giftWrapWriteSucceeded = false;
  var giftWrapMutationTask = queueExternalCartMutation(
    function (settleMutation) {
      var params = {
        type: "POST",
        url: cartAddUrl,
        data: { id: productId, quantity: 1 },
        dataType: "json",
        timeout: 12000,
        success: function () {
          giftWrapWriteSucceeded = true;
          if (giftWrapSurface === "drawer") {
            settleMutation(null, true);
          } else {
            readCartAfterMutation(true, settleMutation);
          }
        },
        error: function () {
          giftWrapWriteSucceeded = false;
          readCartAfterMutation(false, settleMutation);
        }
      };
      jQuery.ajax(params);
    },
    function (cart, succeeded, batchResult) {
      if (
        !succeeded &&
        giftWrapWriteSucceeded === false &&
        giftWrapFocusIntent
      ) {
        giftWrapFocusIntent.deferUntilEnabled = true;
      }
      if (cart) {
        if (giftWrapSurface === "page") {
          return cartPageUpdate(cart, batchResult, giftWrapFocusIntent);
        }
        if (isCartDrawerOwnershipCurrent(cartDrawerOwnership)) {
          return buildCart(
            cart,
            false,
            null,
            cartDrawerOwnership,
            batchResult,
            giftWrapFocusIntent
          );
        }
        updateCartIndicators(cart);
        restoreCartInteractionState();
      } else if (
        succeeded &&
        giftWrapWriteSucceeded &&
        giftWrapSurface === "drawer" &&
        isCartDrawerOwnershipCurrent(cartDrawerOwnership)
      ) {
        return buildCartFromServerSnapshot(
          false,
          null,
          cartDrawerOwnership,
          batchResult,
          giftWrapFocusIntent
        );
      } else if (!succeeded && giftWrapWriteSucceeded === false) {
        var currentSurfaceRoot =
          giftWrapSurface === "drawer"
            ? cartDrawerOwnership && cartDrawerOwnership.drawer
            : document.querySelector("[data-cart-wrapper]");
        markDeferredCartMutationFocus(
          resolveCartMutationFocusIntent(
            giftWrapFocusIntent,
            currentSurfaceRoot,
            giftWrapSurface === "drawer" && currentSurfaceRoot
              ? currentSurfaceRoot.querySelector("[data-drawer-body]")
              : currentSurfaceRoot,
            batchResult
          )
        );
        restoreCartInteractionState();
      } else if (
        giftWrapSurface === "drawer" &&
        isCartDrawerOwnershipCurrent(cartDrawerOwnership)
      ) {
        var drawerFallbackFocus = resolveCartMutationFocusIntent(
          giftWrapFocusIntent,
          cartDrawerOwnership.drawer,
          cartDrawerOwnership.drawer.querySelector("[data-drawer-body]"),
          batchResult
        );
        if (drawerFallbackFocus) {
          giftWrapFocusIntent.restoreFallbackAfterEnable = true;
        }
        if (showCartDrawerFallback(cartDrawerOwnership) && drawerFallbackFocus) {
          restoreCartMutationFocus(
            drawerFallbackFocus,
            cartDrawerOwnership.drawer
          );
        }
      } else {
        restoreCartInteractionState();
      }
      return null;
    },
    releaseGiftWrapPending
  );
  assignCartMutationFocusSequence(
    giftWrapFocusIntent,
    giftWrapMutationTask
  );
});

var cartPageRenderLifecycle =
  window.UpvanityCartPageRenderLifecycle &&
  typeof window.UpvanityCartPageRenderLifecycle === "object"
    ? window.UpvanityCartPageRenderLifecycle
    : { generation: 0, request: null };
window.UpvanityCartPageRenderLifecycle = cartPageRenderLifecycle;
if (typeof cartPageRenderLifecycle.recovering !== "boolean") {
  cartPageRenderLifecycle.recovering = false;
}
if (typeof cartPageRenderLifecycle.needsRecovery !== "boolean") {
  cartPageRenderLifecycle.needsRecovery = false;
}
if (typeof cartPageRenderLifecycle.suspended !== "boolean") {
  cartPageRenderLifecycle.suspended = false;
}
if (!("owner" in cartPageRenderLifecycle)) {
  cartPageRenderLifecycle.owner = null;
}

var UPV_CART_PAGE_RENDER_REQUEST_TIMEOUT = 10000;

function abortCartPageRenderRequest(request) {
  if (!request || typeof request.abort !== "function") return;
  try {
    request.abort();
  } catch (error) {}
}

function isCartPageRenderCurrent(owner, legacyRequest) {
  if (cartPageRenderLifecycle.suspended) return false;
  if (typeof owner === "number") {
    return (
      cartPageRenderLifecycle.generation === owner &&
      !cartPageRenderLifecycle.owner &&
      cartPageRenderLifecycle.request === legacyRequest
    );
  }
  return (
    !!owner &&
    cartPageRenderLifecycle.generation === owner.generation &&
    cartPageRenderLifecycle.owner === owner
  );
}

function recoverCartPageRenderFailure() {
  if (cartPageRenderLifecycle.recovering) return true;
  if (
    !window.location ||
    typeof window.location.reload !== "function"
  ) return false;
  cartPageRenderLifecycle.recovering = true;
  syncCartMutationCheckoutState();
  try {
    window.location.reload();
    return true;
  } catch (error) {
    cartPageRenderLifecycle.recovering = false;
    syncCartMutationCheckoutState();
    return false;
  }
}

function cancelCartPageRenderRequestForPageHide() {
  var request = cartPageRenderLifecycle.request;
  var owner = cartPageRenderLifecycle.owner;
  cartPageRenderLifecycle.suspended = true;
  cartPageRenderLifecycle.generation += 1;
  cartPageRenderLifecycle.owner = null;
  cartPageRenderLifecycle.request = null;
  cartPageRenderLifecycle.needsRecovery =
    cartPageRenderLifecycle.needsRecovery || Boolean(request || owner);
  abortCartPageRenderRequest(request || (owner && owner.request));
}

function recoverCartPageRenderAfterPageShow(event) {
  if (!event) return;
  var isBackForwardNavigation = event.persisted === true;
  if (!isBackForwardNavigation) {
    try {
      var navigationEntries = window.performance &&
        typeof window.performance.getEntriesByType === "function"
        ? window.performance.getEntriesByType("navigation")
        : [];
      isBackForwardNavigation = Boolean(
        navigationEntries &&
        navigationEntries[0] &&
        navigationEntries[0].type === "back_forward"
      );
    } catch (error) {}
  }
  if (!isBackForwardNavigation) return;
  cartPageRenderLifecycle.suspended = false;
  // A checkout/back navigation can restore an older cart DOM even when no
  // render request was in flight at pagehide. Quantity, GPO properties, and
  // BSS prices are commerce-critical, so a persisted cart page always reloads
  // from Shopify instead of trusting the browser's document snapshot.
  if (document.querySelector("[data-cart-wrapper]")) {
    if (cartPageRenderLifecycle.recovering) return;
    cartPageRenderLifecycle.needsRecovery = false;
    if (!recoverCartPageRenderFailure()) {
      restoreCartInteractionState();
    }
    return;
  }
  cartPageRenderLifecycle.recovering = false;
  if (!cartPageRenderLifecycle.needsRecovery) return;
  cartPageRenderLifecycle.needsRecovery = false;
  if (!recoverCartPageRenderFailure()) {
    restoreCartInteractionState();
  }
}

if (
  cartPageRenderLifecycle.nativeHandlers &&
  typeof window.removeEventListener === "function"
) {
  if (
    typeof cartPageRenderLifecycle.nativeHandlers.pagehide === "function"
  ) {
    window.removeEventListener(
      "pagehide",
      cartPageRenderLifecycle.nativeHandlers.pagehide
    );
  }
  if (
    typeof cartPageRenderLifecycle.nativeHandlers.pageshow === "function"
  ) {
    window.removeEventListener(
      "pageshow",
      cartPageRenderLifecycle.nativeHandlers.pageshow
    );
  }
}
cartPageRenderLifecycle.nativeHandlers = {
  pagehide: cancelCartPageRenderRequestForPageHide,
  pageshow: recoverCartPageRenderAfterPageShow
};
if (typeof window.addEventListener === "function") {
  window.addEventListener(
    "pagehide",
    cartPageRenderLifecycle.nativeHandlers.pagehide
  );
  window.addEventListener(
    "pageshow",
    cartPageRenderLifecycle.nativeHandlers.pageshow
  );
}

function destroyCartPageUpsellLifecycle() {
  var upsellContainer = document.querySelector("[data-cart-upsell]");
  if (
    !upsellContainer ||
    !upsellContainer.classList.contains("flickity-enabled") ||
    typeof Flickity === "undefined" ||
    !Flickity ||
    typeof Flickity.data !== "function"
  ) return;
  var slider = Flickity.data(upsellContainer);
  if (slider && typeof slider.destroy === "function") {
    try {
      slider.destroy();
    } catch (error) {}
  }
}

cartPageUpdate = function (cart, batchResult, focusIntent) {
  if (cartPageRenderLifecycle.suspended) {
    cartPageRenderLifecycle.needsRecovery = true;
    return null;
  }
  var previousRequest = cartPageRenderLifecycle.request;
  var generation = cartPageRenderLifecycle.generation + 1;
  var renderOwner = {
    completed: false,
    generation: generation,
    request: null
  };
  cartPageRenderLifecycle.generation = generation;
  cartPageRenderLifecycle.owner = renderOwner;
  cartPageRenderLifecycle.request = null;
  cartPageRenderLifecycle.needsRecovery = false;
  syncCartMutationCheckoutState();
  abortCartPageRenderRequest(previousRequest);
  if (!isCartPageRenderCurrent(renderOwner)) {
    return cartPageRenderLifecycle.request;
  }
  var noteRequestStateVersion =
    typeof cartNoteLifecycle !== "undefined" && cartNoteLifecycle
      ? cartNoteLifecycle.stateVersion
      : null;
  var renderRequest = null;
  try {
    renderRequest = $.ajax({
      url: mainCartUrl,
      type: "GET",
      dataType: "html",
      timeout: UPV_CART_PAGE_RENDER_REQUEST_TIMEOUT,
      success: function (result) {
        if (!isCartPageRenderCurrent(renderOwner)) return;
        try {
          var replacementCart = $(result).find("[data-cart-wrapper]");
          var currentCartWrapper = document.querySelector(
            "[data-cart-wrapper]"
          );
          var restoreMutationFocus = resolveCartMutationFocusIntent(
            focusIntent,
            currentCartWrapper,
            currentCartWrapper,
            batchResult
          );
          var noteRenderState =
            typeof captureCartNoteRenderState === "function"
              ? captureCartNoteRenderState(currentCartWrapper)
              : null;
          if (
            noteRenderState &&
            typeof noteRequestStateVersion === "number"
          ) {
            noteRenderState.requestStateVersion = noteRequestStateVersion;
          }
          if (!replacementCart.length || !currentCartWrapper) {
            if (!recoverCartPageRenderFailure()) {
              markDeferredCartMutationFocus(restoreMutationFocus);
            }
            return;
          }

          destroyCartPageUpsellLifecycle();
          if (!isCartPageRenderCurrent(renderOwner)) return;
          $(currentCartWrapper).html(replacementCart.html());
          if (!isCartPageRenderCurrent(renderOwner)) return;
          if (typeof hydrateCartNoteControls === "function") {
            hydrateCartNoteControls(
              currentCartWrapper,
              undefined,
              noteRenderState
            );
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }
          if (typeof syncGiftWrapMutationPending === "function") {
            syncGiftWrapMutationPending();
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }
          if (typeof renderCartMutationFailures === "function") {
            renderCartMutationFailures(batchResult, null);
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }
          if (typeof window.shippingEstimates === "function") {
            window.shippingEstimates();
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }
          if (restoreMutationFocus) {
            restoreCartMutationFocusAfterRender(
              restoreMutationFocus,
              currentCartWrapper
            );
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }
          if (typeof restoreCartNoteSelectionAfterRender === "function") {
            restoreCartNoteSelectionAfterRender(
              currentCartWrapper,
              noteRenderState
            );
            if (!isCartPageRenderCurrent(renderOwner)) return;
          }

          notifyCartRendered(cart);
          if (!isCartPageRenderCurrent(renderOwner)) return;
          freeShippingBar(cart);
          if (!isCartPageRenderCurrent(renderOwner)) return;
          upsellCartProducts(cart);
          if (!isCartPageRenderCurrent(renderOwner)) return;
          if (
            animationStatus &&
            typeof AOS !== "undefined" &&
            AOS
          ) {
            AOS.refreshHard();
          }
        } catch (error) {
          if (!isCartPageRenderCurrent(renderOwner)) return;
          if (recoverCartPageRenderFailure()) return;
          try {
            var failedCartWrapper = document.querySelector(
              "[data-cart-wrapper]"
            );
            if (failedCartWrapper) {
              markDeferredCartMutationFocus(
                resolveCartMutationFocusIntent(
                  focusIntent,
                  failedCartWrapper,
                  failedCartWrapper,
                  batchResult
                )
              );
            }
          } catch (focusError) {}
        }
      },
      error: function () {
        if (!isCartPageRenderCurrent(renderOwner)) return;
        try {
          var currentCartWrapper = document.querySelector(
            "[data-cart-wrapper]"
          );
          if (recoverCartPageRenderFailure()) return;
          if (currentCartWrapper) {
            markDeferredCartMutationFocus(
              resolveCartMutationFocusIntent(
                focusIntent,
                currentCartWrapper,
                currentCartWrapper,
                batchResult
              )
            );
          }
        } catch (error) {}
      },
      complete: function () {
        renderOwner.completed = true;
        if (!isCartPageRenderCurrent(renderOwner)) return;
        cartPageRenderLifecycle.owner = null;
        cartPageRenderLifecycle.request = null;
        syncCartMutationCheckoutState();
        try {
          updateCartIndicators(cart);
        } catch (error) {}
        try {
          restoreCartInteractionState();
        } catch (error) {}
      }
    });
  } catch (error) {
    renderOwner.completed = true;
    if (isCartPageRenderCurrent(renderOwner)) {
      cartPageRenderLifecycle.owner = null;
      cartPageRenderLifecycle.request = null;
      syncCartMutationCheckoutState();
      var currentCartWrapper = document.querySelector(
        "[data-cart-wrapper]"
      );
      if (!recoverCartPageRenderFailure() && currentCartWrapper) {
        try {
          markDeferredCartMutationFocus(
            resolveCartMutationFocusIntent(
              focusIntent,
              currentCartWrapper,
              currentCartWrapper,
              batchResult
            )
          );
        } catch (focusError) {}
      }
      try {
        updateCartIndicators(cart);
      } catch (indicatorError) {}
      try {
        restoreCartInteractionState();
      } catch (restoreError) {}
    }
    return null;
  }
  renderOwner.request = renderRequest;
  if (isCartPageRenderCurrent(renderOwner)) {
    cartPageRenderLifecycle.request = renderRequest;
  } else if (!renderOwner.completed) {
    abortCartPageRenderRequest(renderRequest);
  }
  return renderRequest;
};

buildCart = function (
  cart,
  showCart,
  element,
  drawerOwnership,
  batchResult,
  focusIntent,
  renderOptions
) {
  var drawer = drawerOwnership && drawerOwnership.drawer ?
    drawerOwnership.drawer : document.querySelector("[data-side-drawer]");
  if (
    !drawerOwnership &&
    drawer &&
    (drawer.id === "mini__cart" || drawer.classList.contains("mini_cart"))
  ) {
    drawerOwnership = prepareSharedDrawerForCart();
    drawer = drawerOwnership && drawerOwnership.drawer;
  }
  if (!isCartDrawerOwnershipCurrent(drawerOwnership) || !drawer) return null;
  if (cart) updateCartIndicators(cart);
  var drawerBody = drawer.querySelector("[data-drawer-body]");
  if (!drawerBody) return null;

  var previousRenderRequest = drawerOwnership.renderRequest;
  drawerOwnership.renderRequest = null;
  if (
    previousRenderRequest &&
    typeof previousRenderRequest.abort === "function"
  ) {
    try {
      previousRenderRequest.abort();
    } catch (error) {}
  }

  var noteRequestStateVersion =
    typeof cartNoteLifecycle !== "undefined" && cartNoteLifecycle
      ? cartNoteLifecycle.stateVersion
      : null;
  var renderRequest = null;
  try {
    renderRequest = $.ajax({
      url: mainCartUrl + "?view=jsonData",
      type: "GET",
      dataType: "html",
      cache: false,
      timeout: 10000
    });
  } catch (error) {
    recoverCartDrawerRenderFailure(
      showCart,
      focusIntent,
      drawerOwnership,
      drawer,
      drawerBody,
      batchResult,
      renderOptions && renderOptions.focusFallback,
      renderOptions && renderOptions.preserveOnFailure
    );
    return null;
  }
  if (
    !renderRequest ||
    typeof renderRequest.done !== "function" ||
    typeof renderRequest.fail !== "function"
  ) {
    if (renderRequest && typeof renderRequest.abort === "function") {
      try {
        renderRequest.abort();
      } catch (error) {}
    }
    recoverCartDrawerRenderFailure(
      showCart,
      focusIntent,
      drawerOwnership,
      drawer,
      drawerBody,
      batchResult,
      renderOptions && renderOptions.focusFallback,
      renderOptions && renderOptions.preserveOnFailure
    );
    return null;
  }
  drawerOwnership.renderRequest = renderRequest;
  syncCartMutationCheckoutState();
  var failCartDrawerRender = function (status) {
    if (
      !isCartDrawerOwnershipCurrent(drawerOwnership) ||
      drawerOwnership.renderRequest !== renderRequest
    ) return;
    drawerOwnership.renderRequest = null;
    // A navigation may abort the drawer read while preserving this document in
    // BFCache. Retire the exact request before treating that abort as silent so
    // pageshow can start an authoritative snapshot refresh.
    if (status === "abort") {
      syncCartMutationCheckoutState();
      return;
    }
    recoverCartDrawerRenderFailure(
      showCart,
      focusIntent,
      drawerOwnership,
      drawer,
      drawerBody,
      batchResult,
      renderOptions && renderOptions.focusFallback,
      renderOptions && renderOptions.preserveOnFailure
    );
    syncCartMutationCheckoutState();
  };
  renderRequest.done(function (html) {
    if (
      !isCartDrawerOwnershipCurrent(drawerOwnership) ||
      drawerOwnership.renderRequest !== renderRequest ||
      drawer.querySelector("[data-drawer-body]") !== drawerBody
    ) return;
    var snapshotMarkerPresent =
      typeof html === "string" &&
      html.indexOf("data-upv-cart-snapshot") !== -1;
    var serverSnapshot = extractCartDrawerServerSnapshot(html);
    if (
      (snapshotMarkerPresent && !serverSnapshot) ||
      (renderOptions && renderOptions.requireServerSnapshot && !serverSnapshot)
    ) {
      failCartDrawerRender("parsererror");
      return;
    }
    var renderCart = serverSnapshot ? serverSnapshot.cart : cart;
    var renderHtml = serverSnapshot ? serverSnapshot.html : html;
    if (!renderCart || typeof renderHtml !== "string") {
      failCartDrawerRender("parsererror");
      return;
    }
    if (serverSnapshot) updateCartIndicators(renderCart);
    var restoreMutationFocus =
      !showCart &&
      resolveCartMutationFocusIntent(
        focusIntent,
        drawer,
        drawerBody,
        batchResult
      );
    var noteRenderState =
      typeof captureCartNoteRenderState === "function"
        ? captureCartNoteRenderState(drawerBody)
        : null;
    if (noteRenderState && typeof noteRequestStateVersion === "number") {
      noteRenderState.requestStateVersion = noteRequestStateVersion;
    }
    try {
    $(drawerBody).html(renderHtml);
    if (typeof hydrateCartNoteControls === "function") {
      hydrateCartNoteControls(
        drawerBody,
        undefined,
        noteRenderState
      );
    }
    if (typeof syncGiftWrapMutationPending === "function") {
      syncGiftWrapMutationPending();
    }
    if (typeof renderCartMutationFailures === "function") {
      renderCartMutationFailures(batchResult, drawer);
    }
    if (
      restoreMutationFocus &&
      restoreMutationFocus.surface === "drawer" &&
      restoreMutationFocus.role === "note"
    ) {
      revealCartDrawerNoteForFocus(drawer);
    }
    if (!showCart) refreshCartDrawerFocusRotation(drawer);
    if (restoreMutationFocus) {
      restoreCartMutationFocusAfterRender(restoreMutationFocus, drawer);
    }
    if (typeof restoreCartNoteSelectionAfterRender === "function") {
      restoreCartNoteSelectionAfterRender(drawerBody, noteRenderState);
    }
    notifyCartRendered(renderCart);
    freeShippingBar(renderCart);
    upsellCartDrawerProducts(renderCart, drawer, drawerOwnership);
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($(drawer));
      if (element) {
        focusElement = element;
      }
      $(drawer).trigger("focus");
      // $('[data-drawer-body]').find('a:first').trigger('focus');
    }
    if (animationStatus) {
      if (typeof AOS !== "undefined" && AOS) {
        AOS.refreshHard();
      }
    }
    } finally {
      if (drawerOwnership.renderRequest === renderRequest) {
        drawerOwnership.renderRequest = null;
      }
      syncCartMutationCheckoutState();
    }
  });
  renderRequest.fail(function (_xhr, status) {
    failCartDrawerRender(status);
  });
  trackCartDrawerRequest(drawerOwnership, renderRequest);
  return renderRequest;
};

function recoverCartDrawerRenderFailure(
  showCart,
  focusIntent,
  drawerOwnership,
  drawer,
  drawerBody,
  batchResult,
  focusFallback,
  preserveOnFailure
) {
  if (!isCartDrawerOwnershipCurrent(drawerOwnership)) return false;
  if (preserveOnFailure && drawerBody && drawerBody.innerHTML) {
    restoreCartInteractionState();
    return true;
  }
  var restoreMutationFocus =
    !showCart &&
    resolveCartMutationFocusIntent(
      focusIntent,
      drawer,
      drawerBody,
      batchResult
    );
  if (
    focusIntent &&
    focusIntent.deferUntilEnabled === true
  ) {
    markDeferredCartMutationFocus(restoreMutationFocus);
    restoreCartInteractionState();
    return true;
  }
  if (
    showCartDrawerFallback(drawerOwnership, focusFallback) &&
    restoreMutationFocus
  ) {
    restoreCartMutationFocus(restoreMutationFocus, drawer);
  }
  return true;
}

function isValidCartDrawerServerSnapshot(cart) {
  if (
    !cart ||
    typeof cart !== "object" ||
    typeof cart.item_count !== "number" ||
    cart.item_count < 0 ||
    typeof cart.original_total_price !== "number" ||
    !Array.isArray(cart.items)
  ) return false;
  for (var index = 0; index < cart.items.length; index += 1) {
    var item = cart.items[index];
    if (
      !item ||
      typeof item !== "object" ||
      typeof item.quantity !== "number" ||
      item.quantity < 0 ||
      typeof item.product_id === "undefined"
    ) return false;
  }
  return true;
}

function extractCartDrawerServerSnapshot(html) {
  if (typeof html !== "string") return null;
  var snapshotPattern = /^\s*<script type="application\/json" data-upv-cart-snapshot>([\s\S]*?)<\/script>\s*/i;
  var snapshotMatch = snapshotPattern.exec(html);
  if (!snapshotMatch) return null;
  var cart = null;
  try {
    cart = JSON.parse(snapshotMatch[1]);
  } catch (error) {
    return null;
  }
  if (!isValidCartDrawerServerSnapshot(cart)) return null;
  return {
    cart: cart,
    html: html.slice(snapshotMatch[0].length)
  };
}

function buildCartFromServerSnapshot(
  showCart,
  element,
  drawerOwnership,
  batchResult,
  focusIntent,
  focusFallback
) {
  return buildCart(
    null,
    showCart,
    element,
    drawerOwnership,
    batchResult,
    focusIntent || null,
    {
      focusFallback: focusFallback === true,
      requireServerSnapshot: true
    }
  );
}

var cartDrawerSnapshotLifecycle =
  window.UpvanityCartDrawerSnapshotLifecycle &&
  typeof window.UpvanityCartDrawerSnapshotLifecycle === "object"
    ? window.UpvanityCartDrawerSnapshotLifecycle
    : {};
window.UpvanityCartDrawerSnapshotLifecycle = cartDrawerSnapshotLifecycle;

function getOpenCartDrawerOwnership() {
  var drawer = document.querySelector("[data-side-drawer]");
  var ownership = drawer && drawer.upvCartDrawerOwnership;
  var body = document.body;
  var drawerIsOpen = Boolean(
    body &&
    body.classList &&
    (
      body.classList.contains("side_Drawer_open") ||
      body.classList.contains("yv_side_Drawer_open")
    )
  );
  if (
    !drawerIsOpen ||
    !ownership ||
    ownership.owner !== "cart" ||
    !isCartDrawerOwnershipCurrent(ownership)
  ) return null;
  return ownership;
}

function captureCartDrawerRefreshFocus(drawer) {
  var activeElement = document.activeElement;
  if (
    !drawer ||
    !activeElement ||
    typeof drawer.contains !== "function" ||
    !drawer.contains(activeElement)
  ) return null;
  var focusIntent = captureCartMutationFocus(activeElement, "drawer");
  if (!focusIntent) {
    focusIntent = captureCartMutationContextFocus(
      activeElement,
      "drawer",
      drawer
    );
  }
  return focusIntent;
}

function refreshOpenCartDrawerSnapshot() {
  var drawerOwnership = getOpenCartDrawerOwnership();
  if (!drawerOwnership) return null;
  if (drawerOwnership.renderRequest) return drawerOwnership.renderRequest;
  var now = Date.now();
  if (
    typeof cartDrawerSnapshotLifecycle.lastRefreshAt === "number" &&
    now - cartDrawerSnapshotLifecycle.lastRefreshAt < 500
  ) return null;
  var drawer = drawerOwnership.drawer;
  var focusIntent = captureCartDrawerRefreshFocus(drawer);
  var renderAfterPendingMutations = function (
    cart,
    succeeded,
    batchResult
  ) {
    if (!isCartDrawerOwnershipCurrent(drawerOwnership)) return null;
    if (!cart && !succeeded) {
      restoreCartInteractionState();
      return null;
    }
    cartDrawerSnapshotLifecycle.lastRefreshAt = Date.now();
    return buildCart(
      cart || null,
      false,
      null,
      drawerOwnership,
      batchResult,
      focusIntent,
      {
        preserveOnFailure: true,
        requireServerSnapshot: !cart
      }
    );
  };
  if (deferCartReadUntilMutationsSettle(renderAfterPendingMutations)) {
    return null;
  }
  cartDrawerSnapshotLifecycle.lastRefreshAt = now;
  return buildCart(
    null,
    false,
    null,
    drawerOwnership,
    { allSucceeded: true, failures: [] },
    focusIntent,
    {
      preserveOnFailure: true,
      requireServerSnapshot: true
    }
  );
}

function installCartDrawerSnapshotLifecycle() {
  if (
    cartDrawerSnapshotLifecycle.pagehideHandler &&
    typeof window.removeEventListener === "function"
  ) {
    window.removeEventListener(
      "pagehide",
      cartDrawerSnapshotLifecycle.pagehideHandler
    );
  }
  if (
    cartDrawerSnapshotLifecycle.pageshowHandler &&
    typeof window.removeEventListener === "function"
  ) {
    window.removeEventListener(
      "pageshow",
      cartDrawerSnapshotLifecycle.pageshowHandler
    );
  }
  if (
    cartDrawerSnapshotLifecycle.visibilityHandler &&
    typeof document.removeEventListener === "function"
  ) {
    document.removeEventListener(
      "visibilitychange",
      cartDrawerSnapshotLifecycle.visibilityHandler
    );
  }
  cartDrawerSnapshotLifecycle.pagehideHandler = function () {
    var drawerOwnership = getOpenCartDrawerOwnership();
    if (!drawerOwnership) return;
    // Do not let the short freshness gate suppress the first BFCache refresh.
    cartDrawerSnapshotLifecycle.lastRefreshAt = 0;
    var renderRequest = drawerOwnership.renderRequest;
    if (!renderRequest) return;
    drawerOwnership.renderRequest = null;
    if (typeof renderRequest.abort === "function") {
      try {
        renderRequest.abort();
      } catch (error) {}
    }
  };
  cartDrawerSnapshotLifecycle.pageshowHandler = function (event) {
    if (event && event.persisted === true) {
      refreshOpenCartDrawerSnapshot();
    }
  };
  cartDrawerSnapshotLifecycle.visibilityHandler = function () {
    if (document.visibilityState === "visible") {
      refreshOpenCartDrawerSnapshot();
    }
  };
  if (typeof window.addEventListener === "function") {
    window.addEventListener(
      "pagehide",
      cartDrawerSnapshotLifecycle.pagehideHandler
    );
    window.addEventListener(
      "pageshow",
      cartDrawerSnapshotLifecycle.pageshowHandler
    );
  }
  if (typeof document.addEventListener === "function") {
    document.addEventListener(
      "visibilitychange",
      cartDrawerSnapshotLifecycle.visibilityHandler
    );
  }
}

installCartDrawerSnapshotLifecycle();

$(document).on("click","[data-drawer-side-header]",function(){
  if($(this).closest(".yv-upsell-drawer").hasClass("active")){
    $(this).closest(".yv-upsell-drawer").removeClass("active")
  }else{
     $(this).closest(".yv-upsell-drawer").addClass("active")
  }
})

var UPV_CART_DRAWER_UPSELL_REQUEST_TIMEOUT = 10000;

function cancelCartDrawerUpsellRequest(drawerOwnership) {
  if (!drawerOwnership) return null;
  var request = drawerOwnership.upsellRequest || null;
  drawerOwnership.upsellRequest = null;
  if (request && Array.isArray(drawerOwnership.requests)) {
    var requestIndex = drawerOwnership.requests.indexOf(request);
    if (requestIndex > -1) drawerOwnership.requests.splice(requestIndex, 1);
  }
  if (request && typeof request.abort === "function") {
    try {
      request.abort();
    } catch (error) {}
  }
  return request;
}

function isCartDrawerUpsellRequestCurrent(
  drawerOwnership,
  request,
  drawer,
  upsellContainer
) {
  return Boolean(
    isCartDrawerOwnershipCurrent(drawerOwnership) &&
    drawerOwnership.upsellRequest === request &&
    drawer &&
    typeof drawer.contains === "function" &&
    drawer.contains(upsellContainer) &&
    drawer.querySelector("[data-drawer-side-content]") === upsellContainer
  );
}

function hideCartDrawerUpsell(upsellDrawer) {
  if (!upsellDrawer || !upsellDrawer.classList) return;
  upsellDrawer.classList.add("hidden");
  upsellDrawer.classList.remove("active");
}

function upsellCartDrawerProducts(cart, drawer, drawerOwnership) {
  cancelCartDrawerUpsellRequest(drawerOwnership);
  if(
    cart &&
    cart.item_count != 0 &&
    Array.isArray(cart.items) &&
    cart.items.length > 0 &&
    drawer &&
    isCartDrawerOwnershipCurrent(drawerOwnership)
  ){
    if(drawer.querySelector("[data-drawer-side-content]")){
      let upsellContainer=drawer.querySelector("[data-drawer-side-content]");
      let upsellDrawer=upsellContainer.closest(".yv-upsell-drawer") ||
        drawer.querySelector(".yv-upsell-drawer");
      if(!upsellDrawer) return null;
      let intent=upsellContainer.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellContainer.getAttribute("data-limit");
        let upsellRequest=null;
        try {
          upsellRequest=$.ajax({
            url: window.Shopify.routes.root + "recommendations/products",
            type: "GET",
            dataType: "html",
            timeout: UPV_CART_DRAWER_UPSELL_REQUEST_TIMEOUT,
            global: false,
            data: {
              product_id: productId,
              limit: limit,
              section_id: "upsell-products",
              intent: intent
            }
          });
        } catch (error) {
          hideCartDrawerUpsell(upsellDrawer);
          return null;
        }
        if (
          !upsellRequest ||
          typeof upsellRequest.done !== "function" ||
          typeof upsellRequest.fail !== "function" ||
          typeof upsellRequest.always !== "function"
        ) {
          if (upsellRequest && typeof upsellRequest.abort === "function") {
            try {
              upsellRequest.abort();
            } catch (error) {}
          }
          hideCartDrawerUpsell(upsellDrawer);
          return null;
        }
        drawerOwnership.upsellRequest=upsellRequest;
        upsellRequest.done(function (text) {
            if (!isCartDrawerUpsellRequestCurrent(
              drawerOwnership,
              upsellRequest,
              drawer,
              upsellContainer
            )) return;
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
               upsellContainer.innerHTML = recommendations.innerHTML;
                upsellDrawer.classList.remove('hidden')
            }else{
              hideCartDrawerUpsell(upsellDrawer)
            }
         });
        upsellRequest.fail(function (_xhr, status) {
          if (
            status === "abort" ||
            !isCartDrawerUpsellRequestCurrent(
              drawerOwnership,
              upsellRequest,
              drawer,
              upsellContainer
            )
          ) return;
          hideCartDrawerUpsell(upsellDrawer);
        });
        upsellRequest.always(function () {
          if (drawerOwnership.upsellRequest === upsellRequest) {
            drawerOwnership.upsellRequest = null;
          }
        });
        trackCartDrawerRequest(drawerOwnership, upsellRequest);
        return upsellRequest;
      }
      else{
        if(upsellContainer.children.length > 0){
          upsellDrawer.classList.remove('hidden')
        }
        else{
          hideCartDrawerUpsell(upsellDrawer)
        }
      }
    }  
  }
  return null;
}

function upsellCartProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-cart-upsell-wrapper]")){
      let upsellWrapper=document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer=upsellWrapper.querySelector("[data-cart-upsell]");
      let intent=upsellWrapper.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellWrapper.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              if(window.innerWidth >= 768 ){
                if(upsellContainer.classList.contains('flickity-enabled')){
                  let slider = Flickity.data(upsellContainer);
                  if(slider){
                    slider.destroy();
                     upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                  }
                }
                else{
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                }
              }
              else{
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove('hidden')
              }
            }else{
              upsellWrapper.classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.classList.contains('flickity-enabled')){
            let slider = Flickity.data(upsellContainer);
            if(slider){
              slider.destroy();
            }
        }
        if(upsellContainer.children.length > 0){
          if(window.innerWidth >= 768 ){
              upsellWrapper.classList.remove('hidden')
              flickitySlider(jQuery(upsellContainer));
          }
          else{
              upsellWrapper.classList.remove('hidden')
          }
        }
        else{
          upsellWrapper.classList.add('hidden')
        }
      }
    }  
  }
}
